<template>
  <panel-navigation class="fill-height" :aiagent="true">
    <buy-number ref="buyNumber"></buy-number>

    <div class="retell-app-viewport bg-gray-50 flex flex-col h-screen overflow-hidden">
      <!-- Top Navigation Header -->
      <header v-if="me" class="retell-header-fixed bg-white border-b border-gray-200 flex-shrink-0">
        <!-- Desktop Header Layout (mdAndUp) -->
        <div class="d-none d-md-flex align-center justify-between fill-height px-3 w-full">
          <div class="d-flex align-center">
          <a href="javascript: void(0);" @click="$router.go(-1)" class="d-flex align-center mr-1 text-decoration-none">
            <i class="mdi mdi-chevron-left text-gray-600" style="font-size: 24px;"></i>
          </a>

          <!-- Editable Label -->
          <div class="d-flex align-center mr-2" v-if="activeSetting">
            <input
              type="text"
              v-model="activeSetting.label"
              class="retell-inline-input text-sm font-semibold text-gray-800"
              placeholder="Agent Label..."
              style="width: 300px;"
            />
          </div>

          <!-- Compact Agent Info & Controls Pill Bar -->
          <div v-if="me.integrations.bland.status == 1 && activeSetting" class="d-flex align-center gap-2">
            <!-- Phone Number Dropdown Selector + Copy Icon -->
            <div class="retell-pill">
              <i class="mdi mdi-phone-outline mr-1 text-gray-500 text-xs"></i>
              <select
                v-model="blandNumberSelected"
                @change="getIdFromBlandNumberSelect"
                class="retell-select-clean text-xs font-medium mr-1"
              >
                <option
                  v-for="(item, idx) in me.integrations.bland.settings"
                  :key="idx"
                  :value="item"
                >
                  {{ item.phone_number }} {{ item.label ? `(${item.label})` : '' }}
                </option>
              </select>
              <a
                href="javascript: void(0);"
                v-clipboard:copy="activeSetting.phone_number"
                v-clipboard:success="onCopyAiNumber"
                v-clipboard:error="onErrorAiNumber"
                class="d-flex align-center text-gray-500 hover:text-gray-800 text-decoration-none"
                title="Copy Phone Number"
              >
                <i class="mdi mdi-content-copy" style="font-size: 14px;"></i>
              </a>
            </div>

            <!-- Provider Selection Pill -->
            <div class="retell-pill">
              <i class="mdi mdi-server-network mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_source" class="retell-select-clean text-xs font-medium">
                <option value="retell">Retell</option>
                <option value="ultravox">Ultravox</option>
                <option value="openai">OpenAI (ChatGPT)</option>
                <option value="vertex">Vertex</option>
                <option value="elevenlabs">ElevenLabs</option>
              </select>
            </div>

            <!-- Dynamic Model Selector Pill (per Provider) -->
            <div class="retell-pill" v-show="activeSetting.voice_source === 'retell'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.retell_model" class="retell-select-clean text-xs font-medium">
                <option value="gpt-4.1">GPT 4.1</option>
                <option value="gpt-4.1-mini">GPT 4.1 Mini</option>
                <option value="gpt-4.1-nano">GPT 4.1 Nano</option>
                <option value="gpt-5.1">GPT 5.1</option>
                <option value="gpt-5">GPT 5</option>
                <option value="gpt-5-mini">GPT 5 Mini</option>
                <option value="gpt-5-nano">GPT 5 Nano</option>
                <option value="claude-4.5-sonnet">Claude 4.5 Sonnet</option>
                <option value="claude-4.5-haiku">Claude 4.5 Haiku</option>
                <option value="gemini-2.5-flash">Gemini 2.5 Flash</option>
                <option value="gemini-2.5-flash-lite">Gemini 2.5 Flash Lite</option>
              </select>
            </div>

            <div class="retell-pill" v-show="activeSetting.voice_source === 'ultravox'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.ultravox_model" class="retell-select-clean text-xs font-medium">
                <option value="fixie-ai/ultravox">fixie-ai/ultravox</option>
              </select>
            </div>

            <div class="retell-pill" v-show="activeSetting.voice_source === 'elevenlabs'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.elevenlabs_model" class="retell-select-clean text-xs font-medium">
                <option value="eleven_flash_v2_5">Flash v2.5</option>
                <option value="eleven_flash_v2">Flash v2</option>
                <option value="eleven_turbo_v2_5">Turbo v2.5</option>
                <option value="eleven_turbo_v2">Turbo v2</option>
                <option value="eleven_multilingual_v2">Multilingual v2</option>
              </select>
            </div>

            <div class="retell-pill" v-show="activeSetting.voice_source === 'openai'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.openai_model" class="retell-select-clean text-xs font-medium">
                <option value="gpt-live-1">GPT-Live-1</option>
                <option value="gpt-realtime-2.1">GPT Realtime 2.1</option>
                <option value="gpt-realtime-2.1-mini">GPT Realtime 2.1 Mini</option>
                <option value="gpt-realtime-1.5">GPT Realtime 1.5</option>
                <option value="gpt-4o-realtime-preview">GPT-4o Realtime</option>
                <option value="gpt-4o-mini-realtime-preview">GPT-4o Mini Realtime</option>
              </select>
            </div>

            <!-- Dynamic Voice Selection Pill (per Provider) -->
            <div class="retell-pill" v-show="activeSetting.voice_source === 'retell'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_retell" class="retell-select-clean text-xs font-medium">
                <option v-for="v in retellVoices" :key="v.voice_id" :value="v.voice_id">
                  {{ v.voice_name || v.voice_id }}
                </option>
              </select>
            </div>

            <div class="retell-pill" v-show="activeSetting.voice_source === 'ultravox'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_ultravox" class="retell-select-clean text-xs font-medium">
                <option v-for="v in ultravoxVoices" :key="v.voiceId" :value="v.voiceId">
                  {{ v.name }}
                </option>
              </select>
            </div>

            <div class="retell-pill" v-show="activeSetting.voice_source === 'vertex'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_vertex" class="retell-select-clean text-xs font-medium">
                <option v-for="v in vertexVoices" :key="v.id" :value="v.id">
                  {{ v.name }}
                </option>
              </select>
            </div>

            <div class="retell-pill" v-show="activeSetting.voice_source === 'openai'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.openai_voice" class="retell-select-clean text-xs font-medium">
                <option v-for="v in openaiVoices" :key="v.id" :value="v.id">
                  {{ v.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="d-flex align-center gap-2">
          <!-- Toggle Tester Panel Button -->
          <button
            class="retell-btn-secondary text-xs font-semibold px-3 py-2 rounded-md d-flex align-center"
            @click="showTester = !showTester"
          >
            <i class="mdi mdi-forum-outline mr-1 text-sm"></i>
            {{ showTester ? 'Hide Tester' : 'Test Prompt' }}
          </button>

          <!-- High-Contrast Save Button -->
          <button
            class="retell-btn-primary text-xs font-semibold px-3 py-2 rounded-md"
            :class="{ 'opacity-50 pointer-events-none': savingBland }"
            @click="saveBlandSettings()"
          >
            <i v-if="savingBland" class="mdi mdi-loading mdi-spin mr-1"></i>
            Save Changes
          </button>
        </div>
        </div>

        <!-- Mobile Header Layout (smAndDown) -->
        <div class="d-flex d-md-none flex-column w-full bg-white px-3 py-2">
          <!-- Mobile Top Row: Back, Label, Test, and Save Changes -->
          <div class="d-flex align-center justify-between w-full">
            <div class="d-flex align-center flex-grow-1 mr-2" style="min-width: 0;">
              <a href="javascript: void(0);" @click="$router.go(-1)" class="d-flex align-center mr-1 text-decoration-none">
                <i class="mdi mdi-chevron-left text-gray-600" style="font-size: 24px;"></i>
              </a>

              <div v-if="activeSetting" class="d-flex align-center flex-grow-1" style="min-width: 0;">
                <input
                  type="text"
                  v-model="activeSetting.label"
                  class="retell-inline-input text-xs sm:text-sm font-bold text-gray-800 flex-grow-1"
                  placeholder="Agent Label..."
                  style="min-width: 60px; max-width: 140px;"
                />
                <i class="mdi mdi-pencil-outline text-gray-400 text-xs ml-0.5"></i>
              </div>
            </div>

            <div class="d-flex align-center gap-1.5 flex-shrink-0">
              <!-- Prominent Save Changes Button -->
              <button
                class="retell-btn-primary text-xs font-bold px-3 py-1.5 rounded-md d-flex align-center shadow-sm"
                :class="{ 'opacity-50 pointer-events-none': savingBland }"
                @click="saveBlandSettings()"
              >
                <i v-if="savingBland" class="mdi mdi-loading mdi-spin mr-1"></i>
                <i v-else class="mdi mdi-content-save mr-1"></i>
                <span>Save<span class="d-none d-sm-inline"> Changes</span></span>
              </button>
            </div>
          </div>

          <!-- Mobile Horizontally Scrollable Pills Strip -->
          <div v-if="me.integrations.bland.status == 1 && activeSetting" class="mobile-pills-bar d-flex align-center gap-2 mt-2 pb-0.5 overflow-x-auto w-full">
            <!-- Phone Number Selector -->
            <div class="retell-pill flex-shrink-0">
              <i class="mdi mdi-phone-outline mr-1 text-gray-500 text-xs"></i>
              <select
                v-model="blandNumberSelected"
                @change="getIdFromBlandNumberSelect"
                class="retell-select-clean text-xs font-medium mr-1"
                style="max-width: 140px;"
              >
                <option
                  v-for="(item, idx) in me.integrations.bland.settings"
                  :key="idx"
                  :value="item"
                >
                  {{ item.phone_number }} {{ item.label ? `(${item.label})` : '' }}
                </option>
              </select>
              <a
                href="javascript: void(0);"
                v-clipboard:copy="activeSetting.phone_number"
                v-clipboard:success="onCopyAiNumber"
                v-clipboard:error="onErrorAiNumber"
                class="d-flex align-center text-gray-500 hover:text-gray-800 text-decoration-none"
                title="Copy Phone Number"
              >
                <i class="mdi mdi-content-copy" style="font-size: 13px;"></i>
              </a>
            </div>

            <!-- Provider Selection Pill -->
            <div class="retell-pill flex-shrink-0">
              <i class="mdi mdi-server-network mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_source" class="retell-select-clean text-xs font-medium">
                <option value="retell">Retell</option>
                <option value="ultravox">Ultravox</option>
                <option value="openai">OpenAI (ChatGPT)</option>
                <option value="vertex">Vertex</option>
                <option value="elevenlabs">ElevenLabs</option>
              </select>
            </div>

            <!-- Dynamic Model Selector Pill (per Provider) -->
            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'retell'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.retell_model" class="retell-select-clean text-xs font-medium">
                <option value="gpt-4.1">GPT 4.1</option>
                <option value="gpt-4.1-mini">GPT 4.1 Mini</option>
                <option value="gpt-4.1-nano">GPT 4.1 Nano</option>
                <option value="gpt-5.1">GPT 5.1</option>
                <option value="gpt-5">GPT 5</option>
                <option value="gpt-5-mini">GPT 5 Mini</option>
                <option value="gpt-5-nano">GPT 5 Nano</option>
                <option value="claude-4.5-sonnet">Claude 4.5 Sonnet</option>
                <option value="claude-4.5-haiku">Claude 4.5 Haiku</option>
                <option value="gemini-2.5-flash">Gemini 2.5 Flash</option>
                <option value="gemini-2.5-flash-lite">Gemini 2.5 Flash Lite</option>
              </select>
            </div>

            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'ultravox'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.ultravox_model" class="retell-select-clean text-xs font-medium">
                <option value="fixie-ai/ultravox">fixie-ai/ultravox</option>
              </select>
            </div>

            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'elevenlabs'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.elevenlabs_model" class="retell-select-clean text-xs font-medium">
                <option value="eleven_flash_v2_5">Flash v2.5</option>
                <option value="eleven_flash_v2">Flash v2</option>
                <option value="eleven_turbo_v2_5">Turbo v2.5</option>
                <option value="eleven_turbo_v2">Turbo v2</option>
                <option value="eleven_multilingual_v2">Multilingual v2</option>
              </select>
            </div>

            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'openai'">
              <i class="mdi mdi-cpu mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.openai_model" class="retell-select-clean text-xs font-medium">
                <option value="gpt-live-1">GPT-Live-1</option>
                <option value="gpt-realtime-2.1">GPT Realtime 2.1</option>
                <option value="gpt-realtime-2.1-mini">GPT Realtime 2.1 Mini</option>
                <option value="gpt-realtime-1.5">GPT Realtime 1.5</option>
                <option value="gpt-4o-realtime-preview">GPT-4o Realtime</option>
                <option value="gpt-4o-mini-realtime-preview">GPT-4o Mini Realtime</option>
              </select>
            </div>

            <!-- Dynamic Voice Selection Pill (per Provider) -->
            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'retell'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_retell" class="retell-select-clean text-xs font-medium">
                <option v-for="v in retellVoices" :key="v.voice_id" :value="v.voice_id">
                  {{ v.voice_name || v.voice_id }}
                </option>
              </select>
            </div>

            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'ultravox'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_ultravox" class="retell-select-clean text-xs font-medium">
                <option v-for="v in ultravoxVoices" :key="v.voiceId" :value="v.voiceId">
                  {{ v.name }}
                </option>
              </select>
            </div>

            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'vertex'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.voice_vertex" class="retell-select-clean text-xs font-medium">
                <option v-for="v in vertexVoices" :key="v.id" :value="v.id">
                  {{ v.name }}
                </option>
              </select>
            </div>

            <div class="retell-pill flex-shrink-0" v-show="activeSetting.voice_source === 'openai'">
              <i class="mdi mdi-account-voice mr-1 text-gray-500 text-xs"></i>
              <select v-model="activeSetting.openai_voice" class="retell-select-clean text-xs font-medium">
                <option v-for="v in openaiVoices" :key="v.id" :value="v.id">
                  {{ v.name }}
                </option>
              </select>
            </div>
          </div>

        </div>
      </header>

      <!-- Main Workspace Container -->
      <div v-if="me" class="flex-grow-1 p-2 overflow-hidden d-flex retell-workspace-container">
        <!-- Access Required Check -->
        <div v-if="!me.convertly_enabled" class="w-full pa-3">
          <product-access-required product="convertly" />
        </div>

        <!-- Disabled State -->
        <div v-else-if="me.integrations.bland.status == 0" class="w-full">
          <v-alert type="info" dense text class="text-xs">
            <strong>AI Not Enabled</strong>
          </v-alert>
          <div class="mt-2">
            <v-btn color="primary" small @click="$refs.buyNumber.show()">Assign AI Phone Number</v-btn>
            <video-guide class="ml-2" ids="phone-numbers" />
          </div>
        </div>

        <template v-else-if="me.integrations.bland.status == 1 && activeSetting">
          <v-row dense class="fill-height flex-nowrap w-full ma-0 gap-2 retell-workspace-row">
            
            <!-- Left Column: Primary Prompts Canvas (Prompt, AI Assistant, Greeting) -->
            <v-col cols="12" :md="showTester ? 4 : 7" class="fill-height d-flex flex-column pa-0 transition-all retell-canvas-col">
              
              <div class="mb-2"><video-guide ids="prompt" label="Prompt editing &amp; testing" /></div>
              <!-- Version Control Header Bar -->
              <div class="retell-card mb-2 p-2 flex-shrink-0 d-flex flex-wrap align-center justify-space-between bg-white gap-2">
                <div class="d-flex align-center gap-2">
                  <span class="text-xs font-semibold text-gray-700">Prompt Version:</span>
                  <select
                    v-model="selectedVersionId"
                    @change="onVersionChange"
                    class="retell-select-clean text-xs font-semibold border rounded px-2 py-1 bg-gray-50"
                  >
                    <option v-for="ver in promptVersions" :key="ver.id" :value="ver.id">
                      V{{ ver.version_number }} - {{ formatDate(ver.created_at) }} {{ ver.is_active ? '(Active)' : '' }}
                    </option>
                  </select>
                </div>

                <div class="d-flex align-center gap-2">
                  <button
                    class="retell-btn-secondary text-xs px-2 py-1 font-medium d-flex align-center"
                    @click="showDiff = !showDiff"
                    :class="{ 'bg-blue-50 border-blue-300 text-blue-700': showDiff }"
                    title="Toggle between editing and full-text diff view"
                  >
                    <i class="mdi mdi-compare mr-1"></i>
                    {{ showDiff ? 'Edit Prompt' : 'View Diff' }}
                  </button>
                </div>
              </div>

              <!-- Describe Desired Change (AI Prompt Revision Bar) -->
              <div class="retell-card mb-2 p-2 flex-shrink-0 bg-blue-50 border-blue-200">
                <div class="text-xs font-semibold text-blue-900 mb-1 d-flex align-center">
                  <i class="mdi mdi-auto-fix mr-1 text-blue-600"></i> AI Prompt Assistant
                </div>
                <div class="d-flex gap-2">
                  <input
                    type="text"
                    v-model="promptChangeDescription"
                    placeholder="Describe what to change (e.g., 'Make responses shorter and don't give pricing over call')..."
                    class="retell-input text-xs flex-grow-1 bg-white px-2 py-1.5"
                    @keyup.enter="generatePromptChange"
                    :disabled="revisingPrompt"
                  />
                  <button
                    class="retell-btn-primary text-xs px-3 py-1.5 rounded font-medium d-flex align-center"
                    :disabled="revisingPrompt || !promptChangeDescription.trim()"
                    @click="generatePromptChange"
                  >
                    <i v-if="revisingPrompt" class="mdi mdi-loading mdi-spin mr-1"></i>
                    {{ revisingPrompt ? 'Generating...' : 'Apply' }}
                  </button>
                </div>
              </div>

              <!-- System Prompt (Padded Textarea / Diff Container) -->
              <div class="retell-card mb-2 p-2 flex-grow-1 d-flex flex-column" style="min-height: 250px;">
                <div class="d-flex align-center justify-space-between mb-1 flex-shrink-0">
                  <div class="text-xs font-semibold text-gray-700 d-flex align-center gap-2">
                    <span>System Prompt</span>
                    <span v-if="showDiff" class="text-xs font-semibold bg-gray-100 px-2 py-0.5 rounded border border-gray-300">
                      Diff Mode (<span style="color: #15803d; font-weight: 700;">Green = Added</span>, <span style="color: #b91c1c; font-weight: 700;">Red = Removed</span>)
                    </span>
                  </div>
                  <span class="text-caption text-gray-400" style="font-size: 10px;">
                    {{ activeSetting.call_prompt ? activeSetting.call_prompt.length : 0 }} / 7000 chars
                  </span>
                </div>

                <!-- FULL-TEXT INLINE DIFF VIEW (Matches textarea dimensions & style) -->
                <div v-if="showDiff" class="prompt-diff retell-textarea text-xs w-full flex-grow-1 overflow-y-auto">
                  <template v-for="(part, pIdx) in promptDiffParts">
                    <span
                      :key="pIdx"
                      :class="{
                        'prompt-diff-added': part.added,
                        'prompt-diff-removed': part.removed
                      }"
                    >{{ part.value }}</span>
                  </template>
                </div>

                <!-- STANDARD EDITABLE TEXTAREA -->
                <textarea
                  v-else
                  v-model="activeSetting.call_prompt"
                  class="retell-textarea text-xs w-full flex-grow-1"
                  placeholder="Enter the primary instructions for your agent..."
                  :disabled="me && me.allow_changing_promp == 0 && !$store.state.auth.owner"
                ></textarea>

                <div class="text-caption text-gray-400 mt-1 flex-shrink-0" style="font-size: 10px;">
                  The prompt is the top-level training of the agent. Changes will affect AI responses.
                </div>
              </div>

              <!-- Separate Text Prompt Toggle (DIY Mode) -->
              <div class="retell-card mb-2 p-2 flex-shrink-0 d-flex align-center justify-space-between">
                <div>
                  <span class="text-xs font-semibold text-gray-700">Separate Text Prompt</span>
                  <div class="text-caption text-gray-400" style="font-size: 10px;">Enable different instructions for text vs voice</div>
                </div>
                <input type="checkbox" v-model="activeSetting.separate_sms_prompt" class="retell-toggle" />
              </div>

              <!-- SMS Prompt (Only visible if Separate SMS is enabled) -->
              <div
                v-show="activeSetting.separate_sms_prompt"
                class="retell-card mb-2 p-2 flex-grow-1 d-flex flex-column"
              >
                <div class="text-xs font-semibold text-gray-700 mb-1">SMS Prompt</div>
                <textarea
                  v-model="activeSetting.sms_prompt"
                  class="retell-textarea text-xs w-full flex-grow-1"
                  placeholder="Enter SMS follow-up or automated response instructions..."
                  :disabled="me && me.allow_changing_promp == 0 && !$store.state.auth.owner"
                ></textarea>
                <div class="text-caption text-gray-400 mt-1" style="font-size: 10px;">
                  Update your SMS prompt.
                </div>
              </div>

              <!-- Opening Message -->
              <div class="retell-card p-2 flex-shrink-0">
                <div class="text-xs font-semibold text-gray-700 mb-1">Opening Message</div>
                <input
                  type="text"
                  v-model="activeSetting.first_sentence"
                  class="retell-input text-xs w-full px-2.5 py-2"
                  placeholder="e.g., Hello, thank you for calling..."
                />
                <div class="text-caption text-gray-400 mt-1" style="font-size: 10px;">
                  A phrase your call starts with instead of generating one on the fly.
                </div>
              </div>
            </v-col>

            <!-- Center Column: Interactive Prompt Tester Panel (Desktop Only) -->
            <v-col v-if="showTester" cols="12" md="4" class="fill-height pa-0 d-none d-md-flex flex-column retell-tester-col">
              <div class="retell-card fill-height d-flex flex-column p-2 bg-white">
                <div class="border-b pb-2 mb-2 d-flex align-center justify-space-between">
                  <div>
                    <span class="text-xs font-bold text-gray-800 d-flex align-center">
                      <i class="mdi mdi-chat-processing-outline mr-1 text-blue-600"></i> Prompt Tester
                    </span>
                    <div class="text-caption text-gray-400" style="font-size: 10px;">Simulate AI behavior using active prompt</div>
                  </div>
                  <button class="retell-btn-secondary text-xs px-2 py-0.5" @click="resetTesterChat">
                    Clear Chat
                  </button>
                </div>

                <!-- Chat Feed -->
                <div class="playground-messages flex-grow-1 overflow-y-auto mb-2 p-2">
                  <div v-if="testerMessages.length === 0" class="text-center text-gray-400 my-8 text-xs">
                    No messages yet. Send a query below to test the agent prompt.
                  </div>
                  <div
                    v-for="(msg, mIdx) in testerMessages"
                    :key="'tmsg-'+mIdx"
                    class="playground-message"
                    :class="msg.role === 'user' ? 'user' : 'assistant'"
                  >
                    <div class="font-semibold text-gray-500 mb-0.5" style="font-size: 9px;">
                      {{ msg.role === 'user' ? 'You' : 'Agent' }}
                    </div>
                    <div>{{ msg.content }}</div>
                  </div>
                  <div v-if="testingPrompt" class="text-xs text-blue-600 italic pa-1">
                    <i class="mdi mdi-loading mdi-spin mr-1"></i> Agent is generating response...
                  </div>
                </div>

                <!-- Input Field -->
                <div class="d-flex gap-1 border-t pt-2">
                  <input
                    type="text"
                    v-model="testerInput"
                    @keyup.enter="runTesterMessage"
                    placeholder="Type test message..."
                    class="retell-input text-xs flex-grow-1 px-2 py-1.5"
                    :disabled="testingPrompt"
                  />
                  <button
                    class="retell-btn-primary text-xs px-3 py-1.5 rounded"
                    :disabled="testingPrompt || !testerInput.trim()"
                    @click="runTesterMessage"
                  >
                    Send
                  </button>
                </div>
              </div>
            </v-col>

            <!-- Right Column: Single Unified Drawer Card (All Settings) -->
            <v-col cols="12" :md="showTester ? 4 : 5" class="fill-height overflow-y-auto pa-0 retell-drawer-col">
              <div class="retell-drawer-container">
                <v-expansion-panels
                  accordion
                  flat tile
                  class="retell-accordion"
                >

                  <!-- Phone Numbers & Sources -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center justify-between w-full pr-2">
                        <span class="d-flex align-center">
                          <i class="mdi mdi-phone-dial mr-2 text-gray-500"></i> Phone Numbers & Sources
                        </span>
                        <span class="text-xxs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 font-medium">
                          {{ 1 + (activeSetting.additional_numbers ? activeSetting.additional_numbers.length : 0) }} Numbers
                        </span>
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-3">

                      <div class="mb-2"><video-guide ids="phone-numbers,sources" label="Phone number &amp; source guides" /></div>
                      <!-- Primary / Initial Number (Locked as LSA) -->
                      <div class="p-2 mb-2 rounded border border-gray-200 bg-gray-50">
                        <div class="d-flex align-center justify-between mb-1">
                          <div class="d-flex align-center">
                            <span class="text-xs font-semibold text-gray-800 font-mono mr-2">{{ activeSetting.phone_number }}</span>
                            <span class="text-xxs uppercase tracking-wider px-1.5 py-0.5 rounded bg-gray-200 text-gray-600 font-bold">Primary</span>
                          </div>
                          <a
                            href="javascript: void(0);"
                            v-clipboard:copy="activeSetting.phone_number"
                            v-clipboard:success="onCopyAiNumber"
                            v-clipboard:error="onErrorAiNumber"
                            class="text-gray-400 hover:text-gray-700 text-decoration-none"
                            title="Copy Number"
                          >
                            <i class="mdi mdi-content-copy text-xs"></i>
                          </a>
                        </div>
                        <div class="d-flex align-center justify-between mt-1">
                          <div class="d-flex align-center">
                            <img :src="require('@/assets/images/lsa.webp')" style="width: 16px; height: 16px; object-fit: contain; margin-right: 6px;" />
                            <span class="text-xs font-medium text-gray-700">LSA (Google Local Service Ads)</span>
                          </div>
                          <span class="text-xxs text-gray-400 italic">Default</span>
                        </div>
                        <div class="mt-2 pt-2 border-t border-gray-200">
                          <lsa-agent-toggle
                            :key="me.uuid"
                            :account="me"
                            :readonly="!!(profile && profile.settings && profile.settings.role === 'Manager (readonly)')"
                          />
                        </div>
                      </div>

                      <!-- Additional Numbers -->
                      <div v-if="activeSetting.additional_numbers && activeSetting.additional_numbers.length > 0" class="mb-2">
                        <label class="retell-label text-xxs mb-1">Additional Numbers</label>
                        <div
                          v-for="(numItem, nIdx) in activeSetting.additional_numbers"
                          :key="nIdx"
                          class="p-2 mb-1.5 rounded border border-gray-200 bg-white"
                        >
                          <div class="d-flex align-center justify-between mb-1.5">
                            <div class="d-flex align-center">
                              <img :src="phoneSource(numItem.source).icon" :alt="phoneSource(numItem.source).label" :title="phoneSource(numItem.source).text" style="width: 18px; height: 18px; object-fit: contain;" />
                              <span class="text-xs font-semibold text-gray-800 font-mono mr-2 ml-2">{{ numItem.phone_number }}</span>
                              <span class="text-xxs text-gray-600">{{ phoneSource(numItem.source).label }}</span>
                            </div>
                            <div class="d-flex align-center gap-1">
                              <a
                                href="javascript: void(0);"
                                v-clipboard:copy="numItem.phone_number"
                                v-clipboard:success="onCopyAiNumber"
                                v-clipboard:error="onErrorAiNumber"
                                class="text-gray-400 hover:text-gray-700 text-decoration-none mr-2"
                                title="Copy Number"
                              >
                                <i class="mdi mdi-content-copy text-xs"></i>
                              </a>
                              <a
                                href="javascript: void(0);"
                                @click="removeAdditionalNumber(nIdx)"
                                class="text-red-400 hover:text-red-600 text-decoration-none"
                                title="Remove Number"
                              >
                                <i class="mdi mdi-delete-outline text-sm"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Purchase Additional Number Button -->
                      <button
                        class="retell-btn-secondary text-xs px-3 py-1.5 w-full d-flex align-center justify-center mt-2"
                        @click="openBuyAdditionalNumberDialog()"
                      >
                        <i class="mdi mdi-plus-circle-outline mr-1 text-sm text-blue-600"></i>
                        <span>Purchase Additional Number</span>
                      </button>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  
                  <!-- 1. Voice Settings -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-volume-high mr-2 text-gray-500"></i> Voice Settings</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <!-- Retell Controls -->
                      <div v-show="activeSetting.voice_source === 'retell'">
                        <div class="d-flex align-center mb-2">
                          <div class="flex-grow-1 mr-2">
                            <label class="retell-label">Voice Selection</label>
                            <select v-model="activeSetting.voice_retell" class="retell-input text-xs px-2 py-1">
                              <option v-for="v in retellVoices" :key="v.voice_id" :value="v.voice_id">
                                {{ v.voice_name }} ({{ v.voice_id }})
                              </option>
                            </select>
                          </div>
                          <button class="retell-btn-secondary text-xs px-2 py-1 mt-3.5 d-flex align-center" @click="playVoiceRetell" :disabled="playingVoice">
                            <i class="mdi mdi-play text-xs mr-1"></i> Play
                          </button>
                        </div>

                        <div class="mb-2">
                          <label class="retell-label">Voice Model</label>
                          <select v-model="activeSetting.retell_voice_model.model" class="retell-input text-xs px-2 py-1">
                            <option value="eleven_turbo_v2">eleven_turbo_v2</option>
                            <option value="eleven_flash_v2">eleven_flash_v2</option>
                            <option value="eleven_turbo_v2_5">eleven_turbo_v2_5</option>
                            <option value="eleven_flash_v2_5">eleven_flash_v2_5</option>
                            <option value="eleven_multilingual_v2">eleven_multilingual_v2</option>
                            <option value="Play3.0-mini">Play3.0-mini</option>
                            <option value="PlayDialog">PlayDialog</option>
                          </select>
                        </div>

                        <div class="mb-2">
                          <div class="d-flex justify-space-between align-center mb-0.5">
                            <label class="retell-label mb-0">Voice Speed</label>
                            <span class="text-xs text-gray-600 font-mono">{{ activeSetting.retell_voice_model.voice_speed }}</span>
                          </div>
                          <input type="range" min="0.5" max="2" step="0.1" v-model.number="activeSetting.retell_voice_model.voice_speed" class="retell-slider" />
                        </div>

                        <div class="mb-2">
                          <div class="d-flex justify-space-between align-center mb-0.5">
                            <label class="retell-label mb-0">Voice Temperature</label>
                            <span class="text-xs text-gray-600 font-mono">{{ activeSetting.retell_voice_model.voice_temperature }}</span>
                          </div>
                          <input type="range" min="0" max="2" step="0.1" v-model.number="activeSetting.retell_voice_model.voice_temperature" class="retell-slider" />
                        </div>

                        <div class="mb-1">
                          <div class="d-flex justify-space-between align-center mb-0.5">
                            <label class="retell-label mb-0">Voice Volume</label>
                            <span class="text-xs text-gray-600 font-mono">{{ activeSetting.retell_voice_model.volume }}</span>
                          </div>
                          <input type="range" min="0" max="2" step="0.1" v-model.number="activeSetting.retell_voice_model.volume" class="retell-slider" />
                        </div>
                      </div>

                      <!-- Ultravox Controls -->
                      <div v-show="activeSetting.voice_source === 'ultravox'">
                        <div class="mb-2">
                          <label class="retell-label">Ultravox Model</label>
                          <select v-model="activeSetting.ultravox_model" class="retell-input text-xs px-2 py-1">
                            <option value="fixie-ai/ultravox">fixie-ai/ultravox</option>
                          </select>
                        </div>
                        <div class="d-flex align-center mb-2">
                          <div class="flex-grow-1 mr-2">
                            <label class="retell-label">Ultravox Voice</label>
                            <v-select
                              v-model="activeSetting.voice_ultravox"
                              :items="ultravoxVoices"
                              item-text="name"
                              item-value="voiceId"
                              outlined dense hide-details
                              class="retell-v-select"
                            />
                          </div>
                          <button class="retell-btn-secondary text-xs px-2 py-1 mt-3.5 d-flex align-center" @click="playVoiceUltravox" :disabled="playingVoice">
                            <i class="mdi mdi-play text-xs mr-1"></i> Play
                          </button>
                        </div>
                      </div>

                      <!-- Vertex Controls -->
                      <div v-show="activeSetting.voice_source === 'vertex'">
                        <div class="d-flex align-center mb-2">
                          <div class="flex-grow-1 mr-2">
                            <label class="retell-label">Vertex Voice</label>
                            <v-select
                              v-model="activeSetting.voice_vertex"
                              :items="vertexVoices"
                              item-text="name"
                              item-value="id"
                              outlined dense hide-details
                              class="retell-v-select"
                            />
                          </div>
                          <button class="retell-btn-secondary text-xs px-2 py-1 mt-3.5 d-flex align-center" @click="playVoiceVertex" :disabled="playingVoice">
                            <i class="mdi mdi-play text-xs mr-1"></i> Play
                          </button>
                        </div>
                      </div>

                      <!-- ElevenLabs Controls -->
                      <div v-show="activeSetting.voice_source === 'elevenlabs'">
                        <div class="mb-2">
                          <label class="retell-label">ElevenLabs Model</label>
                          <select v-model="activeSetting.elevenlabs_model" class="retell-input text-xs px-2 py-1">
                            <option value="eleven_flash_v2_5">Flash v2.5</option>
                            <option value="eleven_flash_v2">Flash v2</option>
                            <option value="eleven_turbo_v2_5">Turbo v2.5</option>
                            <option value="eleven_turbo_v2">Turbo v2</option>
                            <option value="eleven_multilingual_v2">Multilingual v2</option>
                          </select>
                        </div>
                        <div class="mb-2">
                          <label class="retell-label">Voice Selection</label>
                          <ElevenLabsVoiceSelect
                            v-model="activeSetting.voice_elevenlabs_id"
                            :valueName="activeSetting.voice_elevenlabs_name"
                            :valuePreviewUrl="activeSetting.voice_elevenlabs_preview_url"
                            @change="onElevenVoiceChange"
                          />
                          <button class="retell-btn-secondary text-xs px-2 py-1 mt-1 font-medium d-flex align-center" @click="playVoiceElevenlabs" :disabled="playingVoice">
                            <i class="mdi mdi-play text-xs mr-1"></i> Play
                          </button>
                        </div>
                      </div>

                      <!-- OpenAI Controls -->
                      <div v-show="activeSetting.voice_source === 'openai'">
                        <div class="mb-2">
                          <label class="retell-label">OpenAI Model</label>
                          <select v-model="activeSetting.openai_model" class="retell-input text-xs px-2 py-1">
                            <option value="gpt-live-1">GPT-Live-1 (Full-Duplex Live Voice)</option>
                            <option value="gpt-realtime-2.1">GPT Realtime 2.1 (Reasoning & Tools)</option>
                            <option value="gpt-realtime-2.1-mini">GPT Realtime 2.1 Mini (Fast Reasoning)</option>
                            <option value="gpt-realtime-1.5">GPT Realtime 1.5</option>
                            <option value="gpt-4o-realtime-preview">GPT-4o Realtime Preview</option>
                            <option value="gpt-4o-mini-realtime-preview">GPT-4o Mini Realtime Preview</option>
                          </select>
                        </div>
                        <div class="d-flex align-center mb-2">
                          <div class="flex-grow-1 mr-2">
                            <label class="retell-label">OpenAI Voice</label>
                            <v-select
                              v-model="activeSetting.openai_voice"
                              :items="openaiVoices"
                              item-text="name"
                              item-value="id"
                              outlined dense hide-details
                              class="retell-v-select"
                            />
                          </div>
                          <button class="retell-btn-secondary text-xs px-2 py-1 mt-3.5 d-flex align-center" @click="playVoiceOpenAI" :disabled="playingVoice">
                            <i class="mdi mdi-play text-xs mr-1"></i> Play
                          </button>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 2. Auto Request Reviews Panel -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-star-outline mr-2 text-gray-500"></i> Auto Request Reviews</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Enable Review Requests</span>
                        <input type="checkbox" v-model="activeSetting.auto_request_reviews" class="retell-toggle" />
                      </div>

                      <div v-show="activeSetting.auto_request_reviews" class="mt-2">
                        <label class="retell-label">Request Delay</label>
                        <v-select
                          v-model="activeSetting.auto_request_reviews_delay"
                          :items="['24 Hours', '48 hours', '7 Days', '14 Days', '30 Days']"
                          clearable outlined dense hide-details
                          class="retell-v-select mb-2"
                        />

                        <div class="d-flex align-center justify-space-between my-1">
                          <span class="text-xs font-medium text-gray-700">SMS Channel</span>
                          <input type="checkbox" v-model="activeSetting.auto_request_reviews_sms" class="retell-toggle" />
                        </div>

                        <div class="d-flex align-center justify-space-between my-1">
                          <span class="text-xs font-medium text-gray-700">Voice Call Channel</span>
                          <input type="checkbox" v-model="activeSetting.auto_request_reviews_voice" class="retell-toggle" />
                        </div>

                        <review-email-settings :setting="activeSetting"></review-email-settings>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 3. KnowledgeBase Settings -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-book-open-outline mr-2 text-gray-500"></i> KnowledgeBase</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <p class="text-caption text-gray-500 mb-2" style="font-size: 10px;">
                        The knowledgebase is the second level training of the agent. Multiple files can be uploaded. Accepted extensions: .pdf, .txt, .docx, .mp3, .wav
                      </p>

                      <v-file-input
                        accept="application/pdf,.docx,text/plain,.mp3,.wav"
                        v-model="knowledgebase_file"
                        @change="onUploadKnowledgebase"
                        prepend-icon=""
                        prepend-inner-icon="mdi-file-upload"
                        label="Upload Knowledgebase"
                        outlined dense multiple hide-details
                        class="retell-file-input mb-2"
                      />

                      <div v-if="uploading_knowledgebase" class="text-xs text-gray-500 my-1">
                        Uploading... please wait.
                      </div>

                      <div v-if="activeSetting.knowledgebase_files.length > 0" class="mb-2">
                        <strong class="text-xs text-gray-700">Uploaded Documents:</strong>
                        <div v-for="(item, index) in activeSetting.knowledgebase_files" :key="'knwfile-'+index" class="d-flex align-center justify-space-between py-0.5 text-xs border-b">
                          <span>{{ item.file_name }}</span>
                          <i class="mdi mdi-delete text-red-500 cursor-pointer" @click="deleteKnowledgebaseFile(index)"></i>
                        </div>
                      </div>

                      <div class="mt-2">
                        <label class="retell-label mb-1">Crawl Websites and Audio URLs</label>
                        <div v-for="(item, kwwb_index) in activeSetting.knowledgebase_websites" :key="'knwbwebst-' + kwwb_index" class="d-flex align-center gap-2 mb-1">
                          <input
                            type="text"
                            v-model="activeSetting.knowledgebase_websites[kwwb_index]"
                            placeholder="https://example.com"
                            class="retell-input text-xs flex-grow-1 px-2 py-1"
                          />
                          <i class="mdi mdi-delete text-red-500 cursor-pointer" @click="deleteKnowledgebaseWebsite(kwwb_index)"></i>
                        </div>

                        <button class="retell-btn-secondary text-xs px-2 py-1 mt-1 font-medium" @click="activeSetting.knowledgebase_websites.push('')">
                          + Add Link
                        </button>
                        <p class="text-caption text-gray-400 mt-1" style="font-size: 10px;">
                          Regular website pages or MP3 URLs. Suggested max 3 good quality recordings.
                        </p>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 4. Transfer Settings -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-phone-forward mr-2 text-gray-500"></i> Transfer</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="mb-2">
                        <label class="retell-label">Description (Optional)</label>
                        <textarea
                          v-model="activeSetting.retell_transfer.description"
                          class="retell-textarea text-xs w-full p-2.5"
                          rows="2"
                        ></textarea>
                      </div>

                      <div class="mb-2">
                        <label class="retell-label">Transfer To</label>
                        <select v-model="activeSetting.retell_transfer.transfer_destination.type" class="retell-input text-xs px-2 py-1">
                          <option value="predefined">Static Phone Number</option>
                          <option value="inferred">Dynamic Routing Prompt</option>
                        </select>
                      </div>

                      <div v-if="activeSetting.retell_transfer.transfer_destination.type === 'predefined'" class="mb-2">
                        <label class="retell-label">Static Phone Number</label>
                        <input
                          type="text"
                          v-model="activeSetting.retell_transfer.transfer_destination.number"
                          class="retell-input text-xs w-full px-2 py-1"
                        />
                      </div>

                      <div v-if="activeSetting.retell_transfer.transfer_destination.type === 'inferred'" class="mb-2">
                        <label class="retell-label">Dynamic Routing Prompt</label>
                        <input
                          type="text"
                          v-model="activeSetting.retell_transfer.transfer_destination.prompt"
                          class="retell-input text-xs w-full px-2 py-1"
                        />
                      </div>

                      <div class="mb-2">
                        <label class="retell-label">Type</label>
                        <select v-model="activeSetting.retell_transfer.transfer_type" class="retell-input text-xs px-2 py-1">
                          <option value="cold">Cold Routing</option>
                          <option value="warm">Warm Transfer</option>
                        </select>
                      </div>

                      <div v-if="activeSetting.retell_transfer.transfer_type === 'cold'" class="mb-2">
                        <label class="retell-label">Displayed Phone Number</label>
                        <select v-model="activeSetting.retell_transfer.displayed_phone_number" class="retell-input text-xs px-2 py-1">
                          <option value="retell">Retell Agent's Number</option>
                          <option value="transferee">Transferee's Number</option>
                        </select>
                      </div>

                      <div v-if="activeSetting.retell_transfer.transfer_type === 'warm'" class="mb-2">
                        <label class="retell-label">Debrief Message Mode</label>
                        <select v-model="activeSetting.retell_transfer.warm_transfer_option.debrief_mode" class="retell-input text-xs px-2 py-1">
                          <option value="whisper">Whisper Debrief (Receiving Agent Only - Private)</option>
                          <option value="three_way">Three-Way Debrief (Both Caller & Agent - Public)</option>
                          <option value="both">Both (Whisper & Three-Way)</option>
                        </select>
                      </div>

                      <div v-if="activeSetting.retell_transfer.transfer_type === 'warm'" class="mb-2">
                        <label class="retell-label">Handoff Message Type</label>
                        <select v-model="activeSetting.retell_transfer.warm_transfer_option.type" class="retell-input text-xs px-2 py-1">
                          <option value="prompt">Prompt</option>
                          <option value="static_message">Static Sentence</option>
                        </select>

                        <div v-if="activeSetting.retell_transfer.warm_transfer_option.type === 'prompt'" class="mt-1">
                          <label class="retell-label">Warm Transfer Debrief Prompt</label>
                          <input
                            type="text"
                            v-model="activeSetting.retell_transfer.warm_transfer_option.prompt"
                            placeholder="Say hello to the agent and summarize the user problem to him."
                            class="retell-input text-xs w-full px-2 py-1"
                          />
                        </div>

                        <div v-if="activeSetting.retell_transfer.warm_transfer_option.type === 'static_message'" class="mt-1">
                          <label class="retell-label">Static Message</label>
                          <input
                            type="text"
                            v-model="activeSetting.retell_transfer.warm_transfer_option.message"
                            placeholder="You can take it from here."
                            class="retell-input text-xs w-full px-2 py-1"
                          />
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 5. Follow-Up Settings -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-clock-outline mr-2 text-gray-500"></i> Follow-Up Settings</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <br />

                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Auto Follow-Up</span>
                        <input type="checkbox" v-model="activeSetting.auto_follow_up" class="retell-toggle" />
                      </div>

                      <div class="mt-2">
                        <label class="retell-label">Follow-Up Message</label>
                        <input
                          type="text"
                          v-model="activeSetting.follow_up_message"
                          class="retell-input text-xs w-full px-2 py-1"
                        />
                      </div>

                      <div class="mt-2">
                        <label class="retell-label">Follow-Up Minutes</label>
                        <select v-model="activeSetting.follow_up_minutes" class="retell-input text-xs px-2 py-1">
                          <option v-for="m in [1, 2, 3, 4, 5]" :key="'fum-'+m" :value="m">
                            {{ m }} minutes
                          </option>
                        </select>
                      </div>

                      <br />

                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Secondary Follow-Up</span>
                        <input type="checkbox" v-model="activeSetting.auto_follow_up2" class="retell-toggle" />
                      </div>

                      <div class="mt-2">
                        <label class="retell-label">Follow-Up Message</label>
                        <input
                          type="text"
                          v-model="activeSetting.follow_up2_message"
                          class="retell-input text-xs w-full px-2 py-1"
                        />
                      </div>

                      <div class="mt-2">
                        <label class="retell-label">Follow-Up Minutes</label>
                        <select v-model="activeSetting.follow_up2_minutes" class="retell-input text-xs px-2 py-1">
                          <option v-for="m in [1, 2, 3, 4, 5]" :key="'fum-'+m" :value="m">
                            {{ m }} minutes
                          </option>
                        </select>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 6. Calendar Settings -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-calendar-month mr-2 text-gray-500"></i> Calendar Settings</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="mb-2">
                        <label class="retell-label">Calendar Link</label>
                        <input
                          type="text"
                          v-model="activeSetting.calendar_link"
                          class="retell-input text-xs w-full px-2 py-1"
                        />
                      </div>

                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Enable Calendar Integration</span>
                        <input type="checkbox" v-model="activeSetting.retell_llm_settings.calendar_enabled" class="retell-toggle" />
                      </div>

                      <div v-if="activeSetting.retell_llm_settings.calendar_enabled" class="mt-2">
                        <label class="retell-label">Calendar Type</label>
                        <select v-model="activeSetting.calendar_type" class="retell-input text-xs px-2 py-1">
                          <option value="GHL">GHL</option>
                          <option value="Calendly">Calendly</option>
                        </select>
                      </div>

                      <div v-if="activeSetting.retell_llm_settings.calendar_enabled && activeSetting.calendar_type === 'GHL'" class="mt-2">
                        <label class="retell-label">GHL Calendar Selection</label>
                        <v-select
                          v-model="activeSetting.selected_ghl_calendar_id"
                          :items="serviceOptions"
                          item-text="name"
                          item-value="id"
                          outlined dense hide-details
                          class="retell-v-select"
                          @change="onCalendarChange"
                        >
                          <template v-slot:item="{ item, on, attrs }">
                            <v-list-item v-if="item.header">
                              <v-list-item-content>
                                <v-list-item-title class="subtitle-2 font-weight-bold">{{ item.header }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider v-else-if="item.divider" />
                            <v-list-item v-else v-bind="attrs" v-on="on">
                              <v-list-item-content>
                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-select>

                        <div v-if="currentDurationOptions.length" class="mt-3">
                          <label class="retell-label">Duration Selection</label>
                          <v-select
                            v-model="activeSetting.selected_ghl_duration_option"
                            :items="currentDurationOptions"
                            return-object
                            item-text="duration"
                            outlined dense hide-details
                          >
                            <template v-slot:selection="{ item }">
                              {{ item.duration }} {{ item.durationUnit }}
                            </template>
                            <template v-slot:item="{ item, on, attrs }">
                              <v-list-item v-bind="attrs" v-on="on">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ item.duration }} {{ item.durationUnit }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 7. Speech Settings -->
                  <v-expansion-panel class="retell-panel-border" v-show="activeSetting.voice_source === 'retell'">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-account-voice mr-2 text-gray-500"></i> Speech Settings</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="mb-2">
                        <label class="retell-label">Background Sound</label>
                        <select v-model="activeSetting.retell_speech_settings.ambient_sound" class="retell-input text-xs px-2 py-1">
                          <option :value="null">None</option>
                          <option value="coffee-shop">coffee-shop</option>
                          <option value="convention-hall">convention-hall</option>
                          <option value="summer-outdoor">summer-outdoor</option>
                          <option value="mountain-outdoor">mountain-outdoor</option>
                          <option value="static-noise">static-noise</option>
                          <option value="call-center">call-center</option>
                        </select>
                      </div>

                      <div class="mb-2">
                        <div class="d-flex justify-space-between align-center mb-0.5">
                          <label class="retell-label mb-0">Response Eagerness</label>
                          <span class="text-xs text-gray-600 font-mono">{{ activeSetting.retell_speech_settings.responsiveness }}</span>
                        </div>
                        <input type="range" min="0" max="1" step="0.01" v-model.number="activeSetting.retell_speech_settings.responsiveness" class="retell-slider" />
                        <label class="d-flex align-center mt-1 text-xs text-gray-600 cursor-pointer">
                          <input type="checkbox" v-model="activeSetting.retell_speech_settings.enable_dynamic_responsiveness" class="mr-2" />
                          Dynamically adjust based on user input
                        </label>
                      </div>

                      <div class="mb-2">
                        <div class="d-flex justify-space-between align-center mb-0.5">
                          <label class="retell-label mb-0">Interruption Sensitivity</label>
                          <span class="text-xs text-gray-600 font-mono">{{ activeSetting.retell_speech_settings.interruption_sensitivity }}</span>
                        </div>
                        <input type="range" min="0" max="1" step="0.01" v-model.number="activeSetting.retell_speech_settings.interruption_sensitivity" class="retell-slider" />
                      </div>

                      <div class="mb-2">
                        <label class="retell-label">Reminder Message Frequency</label>
                        <div class="d-flex align-center gap-2">
                          <input type="number" v-model.number="activeSetting.retell_speech_settings.reminder_trigger_ms" class="retell-input text-xs w-16 text-center px-2 py-1" placeholder="10" />
                          <span class="text-xs text-gray-600">seconds</span>
                          <input type="number" v-model.number="activeSetting.retell_speech_settings.reminder_max_count" class="retell-input text-xs w-12 text-center px-2 py-1" placeholder="1" />
                          <span class="text-xs text-gray-600">times</span>
                        </div>
                      </div>

                      <div class="mb-2">
                        <label class="retell-label">Pronunciation Dictionary</label>
                        <div class="d-flex flex-wrap gap-1 mb-1">
                          <div v-for="(p, pIdx) in activeSetting.retell_speech_settings.pronunciation_dictionary" :key="pIdx" class="retell-chip text-xs">
                            <i class="mdi mdi-volume-source mr-1 text-gray-500"></i>
                            <span>{{ p.word }}</span>
                            <i class="mdi mdi-close ml-1 cursor-pointer" @click="removePronunciation(pIdx)"></i>
                          </div>
                        </div>
                        <div class="d-flex gap-1">
                          <input type="text" v-model="newPronunciationWord" placeholder="Word / Phrase" class="retell-input text-xs flex-grow-1 px-2 py-1" />
                          <button class="retell-btn-secondary text-xs px-2 py-1 font-medium" @click="addPronunciation">+ Add</button>
                        </div>
                      </div>

                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Enable Backchannel</span>
                        <input type="checkbox" v-model="activeSetting.retell_speech_settings.enable_backchannel" class="retell-toggle" />
                      </div>

                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Normalize for Speech</span>
                        <input type="checkbox" v-model="activeSetting.retell_speech_settings.normalize_for_speech" class="retell-toggle" />
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-volume-high mr-2 text-gray-500"></i> Recording Notification</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <label class="d-flex align-center justify-space-between my-1 text-xs font-medium text-gray-700">
                        Enable Recording Notification
                        <input type="checkbox" v-model="activeSetting.recording_notification_enabled" class="retell-toggle" />
                      </label>
                      <div class="my-2"><video-guide ids="recording" /></div>
                      <div class="text-caption text-gray-400 mt-1" style="font-size: 10px;">
                        Play a notice before connecting incoming calls to AI or forwarding to a phone number.
                      </div>
                      <textarea
                        v-if="activeSetting.recording_notification_enabled"
                        v-model="activeSetting.recording_notification_message"
                        aria-label="Recording notification message"
                        class="retell-textarea text-xs w-full mt-2"
                        maxlength="1000"
                        rows="2"
                        placeholder="This call may be recorded for quality and training purposes."
                      ></textarea>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 8. Call Settings -->
                  <v-expansion-panel class="retell-panel-border" v-show="activeSetting.voice_source === 'retell'">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-phone-settings mr-2 text-gray-500"></i> Call Settings</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="d-flex align-center justify-space-between my-1">
                        <div>
                          <div class="text-xs font-medium text-gray-700">Voicemail Detection</div>
                        </div>
                        <input type="checkbox" v-model="activeSetting.retell_call_settings.enable_voicemail_detection" class="retell-toggle" />
                      </div>

                      <div v-if="activeSetting.retell_call_settings.enable_voicemail_detection" class="pl-2 border-l-2 border-gray-200 my-1">
                        <div class="mb-1">
                          <label class="retell-label">Voicemail Message</label>
                          <input type="text" v-model="activeSetting.retell_call_settings.voicemail_message" class="retell-input text-xs w-full px-2 py-1" />
                        </div>
                      </div>

                      <div class="d-flex align-center justify-space-between my-1">
                        <div>
                          <div class="text-xs font-medium text-gray-700">User Keypad Input Detection</div>
                        </div>
                        <input type="checkbox" v-model="activeSetting.retell_call_settings.allow_user_dtmf" class="retell-toggle" />
                      </div>

                      <div class="mb-2 mt-2">
                        <div class="d-flex justify-space-between align-center mb-0.5">
                          <label class="retell-label mb-0">End Call on Silence</label>
                          <span class="text-xs text-gray-600 font-mono">{{ (activeSetting.retell_call_settings.end_call_after_silence_ms / 60000).toFixed(1) }} m</span>
                        </div>
                        <input type="range" min="10000" max="600000" step="10000" v-model.number="activeSetting.retell_call_settings.end_call_after_silence_ms" class="retell-slider" />
                      </div>

                      <div class="mb-2">
                        <div class="d-flex justify-space-between align-center mb-0.5">
                          <label class="retell-label mb-0">Max Call Duration</label>
                          <span class="text-xs text-gray-600 font-mono">{{ (activeSetting.retell_call_settings.max_call_duration_ms / 60000).toFixed(1) }} m</span>
                        </div>
                        <input type="range" min="60000" max="3600000" step="60000" v-model.number="activeSetting.retell_call_settings.max_call_duration_ms" class="retell-slider" />
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 9. Chat Widget & Page Specific Prompts -->
                  <v-expansion-panel class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-message-text-outline mr-2 text-gray-500"></i> Chat Widget Settings</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="mb-2">
                        <label class="retell-label">Chat Box Title</label>
                        <input type="text" v-model="activeSetting.widget_title" class="retell-input text-xs w-full px-2 py-1" />
                      </div>

                      <div class="mb-2">
                        <label class="retell-label">Chat Box Description</label>
                        <input type="text" v-model="activeSetting.widget_description" class="retell-input text-xs w-full px-2 py-1" />
                      </div>

                      <div class="mb-2">
                        <label class="retell-label">Floating Chat Position</label>
                        <select v-model="activeSetting.floating_box_position" class="retell-input text-xs px-2 py-1">
                          <option value="Left">Left</option>
                          <option value="Centered">Centered</option>
                          <option value="Right">Right</option>
                        </select>
                      </div>

                      <!-- Page Specific Prompts -->
                      <div class="mt-2 border-t pt-2">
                        <div class="d-flex align-center justify-space-between mb-1">
                          <label class="retell-label mb-0">Page-Specific Widget Prompts</label>
                          <button type="button" class="retell-btn-secondary text-xs px-2 py-0.5 font-medium" @click="addChatWidgetPage()">
                            + Add Page
                          </button>
                        </div>
                        <div v-for="(chatPage, pIdx) in getChatWidgetPages()" :key="'cpage-'+pIdx" class="border rounded p-2 mb-2 bg-gray-50">
                          <div class="d-flex align-center justify-space-between mb-1">
                            <span class="text-xs font-semibold text-gray-700">Page {{ pIdx + 1 }}</span>
                            <i class="mdi mdi-delete text-red-500 cursor-pointer text-xs" @click="removeChatWidgetPage(pIdx)"></i>
                          </div>
                          <input v-model="chatPage.page" placeholder="URL / Path / Query" class="retell-input text-xs mb-1 px-2 py-1" />
                          <textarea v-model="chatPage.prompt" placeholder="Custom Page Prompt..." class="retell-textarea text-xs p-2.5" rows="3"></textarea>
                        </div>
                      </div>

                      <!-- Color Grid -->
                      <div class="grid grid-cols-3 gap-2 my-2">
                        <div>
                          <label class="retell-label">Header</label>
                          <input type="color" v-model="activeSetting.widget_header_color" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Text</label>
                          <input type="color" v-model="activeSetting.widget_text_color" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Box</label>
                          <input type="color" v-model="activeSetting.widget_box_color" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Left Bubble</label>
                          <input type="color" v-model="activeSetting.widget_chat_bubble_left_color" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Right Bubble</label>
                          <input type="color" v-model="activeSetting.widget_chat_bubble_right_color" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Button</label>
                          <input type="color" v-model="activeSetting.widget_button_color" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                      </div>

                      <div class="d-flex align-center justify-space-between my-1">
                        <span class="text-xs font-medium text-gray-700">Show Powered-By</span>
                        <input type="checkbox" v-model="activeSetting.show_powered_by" class="retell-toggle" />
                      </div>

                      <div class="mt-1">
                        <label class="retell-label">Powered By Link</label>
                        <input type="text" v-model="activeSetting.powered_by_link" class="retell-input text-xs w-full px-2 py-1" />
                      </div>

                      <div class="mt-1 mb-2">
                        <label class="retell-label">Powered By Text</label>
                        <input type="text" v-model="activeSetting.powered_by_text" class="retell-input text-xs w-full px-2 py-1" />
                      </div>

                      <!-- Auto Popup Controls -->
                      <div class="d-flex align-center justify-space-between my-1 border-t pt-2">
                        <span class="text-xs font-medium text-gray-700">Auto Popup</span>
                        <input type="checkbox" v-model="activeSetting.auto_popup" class="retell-toggle" />
                      </div>

                      <div v-show="activeSetting.auto_popup" class="mt-1">
                        <label class="retell-label">Auto Popup Delay (Seconds)</label>
                        <input type="number" v-model="activeSetting.auto_popup_seconds" class="retell-input text-xs w-full px-2 py-1" />
                      </div>

                      <ChatWidgetPreview :setting="activeSetting" />

                      <!-- Chat Embed Code -->
                      <div class="mt-2 border-t pt-2">
                        <label class="retell-label mb-1">Embed Code</label>
                        <v-tabs class="retell-tabs">
                          <v-tab class="text-xs">In Content</v-tab>
                          <v-tab class="text-xs">Floating</v-tab>

                          <v-tab-item class="pt-2">
                            <textarea :value="getEmbedCode()" class="retell-textarea text-xs w-full p-2.5 font-mono" rows="4" readonly></textarea>
                          </v-tab-item>

                          <v-tab-item class="pt-2">
                            <textarea :value="getEmbedCodeFloating()" class="retell-textarea text-xs w-full p-2.5 font-mono" rows="4" readonly></textarea>
                          </v-tab-item>
                        </v-tabs>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <!-- 10. Voice Share / Embed Settings Panel (temporarily hidden) -->
                  <v-expansion-panel v-if="false" class="retell-panel-border">
                    <v-expansion-panel-header class="text-xs font-semibold text-gray-700 py-2 px-2.5">
                      <span class="d-flex align-center"><i class="mdi mdi-microphone-outline mr-2 text-gray-500"></i> Voice Share / Embed</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-2.5 pb-2">
                      <div class="mb-2">
                        <label class="retell-label">Voice Widget Title</label>
                        <input type="text" v-model="activeSetting.voice_widget_title" @keyup="reloadVoiceWidget()" class="retell-input text-xs w-full px-2 py-1" />
                      </div>

                      <div class="grid grid-cols-3 gap-2 my-2">
                        <div>
                          <label class="retell-label">Box</label>
                          <input type="color" v-model="activeSetting.voice_widget_box_color" @change="reloadVoiceWidget()" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Text</label>
                          <input type="color" v-model="activeSetting.voice_widget_text_color" @change="reloadVoiceWidget()" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Talk Button</label>
                          <input type="color" v-model="activeSetting.voice_widget_talk_button_color" @change="reloadVoiceWidget()" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">Mute Button</label>
                          <input type="color" v-model="activeSetting.voice_widget_mute_button_color" @change="reloadVoiceWidget()" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                        <div>
                          <label class="retell-label">End Button</label>
                          <input type="color" v-model="activeSetting.voice_widget_end_button_color" @change="reloadVoiceWidget()" class="w-full h-6 cursor-pointer rounded" />
                        </div>
                      </div>

                      <div class="mt-2 border-t pt-2">
                        <label class="retell-label mb-1">Live Preview</label>
                        <div style="width: 100%; height: 260px; border: solid 1px #e2e8f0; border-radius: 6px; overflow: hidden;">
                          <iframe :src="voiceChatWidgetUrl()" :key="voiceChatWidgetKey" style="width: 100%; height: 100%;" allow="microphone"></iframe>
                        </div>
                      </div>

                      <div class="mt-2">
                        <label class="retell-label mb-1">Shareable Link</label>
                        <textarea :value="voiceChatWidgetUrl()" class="retell-textarea text-xs w-full p-2.5 font-mono" rows="2" readonly></textarea>
                      </div>

                      <div class="mt-2">
                        <label class="retell-label mb-1">Embed Code</label>
                        <textarea :value="getVoiceEmbedCode()" class="retell-textarea text-xs w-full p-2.5 font-mono" rows="4" readonly></textarea>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                </v-expansion-panels>

                <!-- Mobile Bottom Save Button (Visible only on mobile) -->
                <div class="d-flex d-md-none p-3 bg-white border-t border-gray-200">
                  <button
                    class="retell-btn-primary text-xs font-bold py-2.5 px-4 rounded-md w-full d-flex align-center justify-center shadow-sm"
                    :class="{ 'opacity-50 pointer-events-none': savingBland }"
                    @click="saveBlandSettings()"
                  >
                    <i v-if="savingBland" class="mdi mdi-loading mdi-spin mr-1"></i>
                    <i v-else class="mdi mdi-content-save mr-1"></i>
                    <span>Save Changes</span>
                  </button>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>

        <!-- Error Alert -->
        <div v-if="errorBland" class="mt-2">
          <v-alert type="error" dense text class="text-xs">
            <div v-html="errorBland"></div>
          </v-alert>
        </div>
      </div>
    </div>

    <!-- Buy Number Dialog (for additional numbers) -->
    <BuyNumber ref="buyNumber" />

  </panel-navigation>

</template>

<script>
import axios from 'axios'
import { phoneSource } from '@/config/phoneSources';
import { mapState } from 'vuex'
import PanelNavigation from '@/components/PanelNavigation.vue'
import LsaAgentToggle from '@/components/LsaAgentToggle.vue'
import BuyNumber from '@/components/dialogs/integrations/buyNumber.vue'
import ElevenLabsVoiceSelect from '@/components/common/ElevenLabsVoiceSelect.vue'
import ProductAccessRequired from '@/components/reusable/ProductAccessRequired.vue'
import ChatWidgetPreview from '@/components/ChatWidgetPreview.vue'

import { VSwitch, VTextField, VTextarea } from 'vuetify/lib';

const ReviewEmailSettings = {
  name: 'ReviewEmailSettings',
  props: {
    setting: {
      type: Object,
      required: true
    }
  },
  render(h) {
    if (!this.setting) return null;

    return h('div', { class: 'w-full mb-2 pt-2 border-t mt-2' }, [
      h('div', { class: 'd-flex align-center justify-space-between mb-1' }, [
        h('span', { class: 'text-xs font-medium text-gray-700' }, 'Email Review Requests'),
        h(VSwitch, {
          props: {
            color: '#48bb78',
            inset: true,
            dense: true,
            hideDetails: true,
            ripple: false,
            value: this.setting.auto_request_reviews_email
          },
          on: {
            change: (val) => {
              this.$set(this.setting, 'auto_request_reviews_email', val);
            }
          }
        })
      ]),

      this.setting.auto_request_reviews_email ? h('div', {
        class: 'mt-2 p-2 bg-gray-50 border border-gray-200 rounded text-xs space-y-2'
      }, [
        h('div', [
          h('label', { class: 'retell-label' }, 'Email Subject:'),
          h(VTextField, {
            props: {
              dense: true,
              outlined: true,
              hideDetails: true,
              placeholder: 'Feedback for {{company_name}}',
              value: this.setting.review_email_subject
            },
            on: {
              input: (val) => {
                this.$set(this.setting, 'review_email_subject', val);
              }
            }
          })
        ]),

        h('div', [
          h('label', { class: 'retell-label' }, 'Email Body:'),
          h(VTextarea, {
            props: {
              dense: true,
              outlined: true,
              rows: 5,
              hideDetails: true,
              placeholder: 'Enter custom email content...',
              value: this.setting.review_email_body
            },
            on: {
              input: (val) => {
                this.$set(this.setting, 'review_email_body', val);
              }
            }
          })
        ])
      ]) : null
    ]);
  }
};

export default {
  metaInfo () {
    return { title: "AI Agent | " + this.$appName }
  },
  components: {
    PanelNavigation,
    LsaAgentToggle,
    BuyNumber,
    ElevenLabsVoiceSelect,
    ProductAccessRequired,
    ChatWidgetPreview,
    ReviewEmailSettings
  },
  data() {
    return {
      selected_bland_number: 0,
      blandNumberSelected: null,
      savingBland: false,
      errorBland: null,
      playingVoice: false,
      knowledgebase_file: null,
      uploading_knowledgebase: false,
      retellVoices: [],
      teams: [],
      serviceOptions: [],
      newPronunciationWord: "",
      voiceChatWidgetKey: 0,

      // Versioning & AI Assistant additions
      promptVersions: [],
      selectedVersionId: null,
      showDiff: false,
      showTester: false,
      testingPrompt: false,
      testerInput: '',
      testerMessages: [],
      lastSavedPrompt: '',
      promptChangeDescription: '',
      revisingPrompt: false,

      vertexVoices: [
        { id: 'en-US-Chirp3-HD-Aoede', name: 'Aoede (female, natural)' },
        { id: 'en-US-Chirp3-HD-Leda', name: 'Leda (female, calm)' },
        { id: 'en-US-Chirp3-HD-Zephyr', name: 'Zephyr (male, smooth)' },
        { id: 'en-US-Chirp3-HD-Charon', name: 'Charon (male, deep)' },
        { id: 'en-US-Chirp3-HD-Fenrir', name: 'Fenrir (male, strong)' },
        { id: 'en-US-Chirp3-HD-Orus', name: 'Orus (male, neutral)' },
        { id: 'en-US-Chirp3-HD-Puck', name: 'Puck (youthful, expressive)' },
        { id: 'en-US-Chirp3-HD-Achernar', name: 'Achernar (female, bright)' }
      ],
      openaiVoices: [
        { id: 'alloy', name: 'Alloy (Neutral, Balanced)' },
        { id: 'ash', name: 'Ash (Soft, Gentle - Male)' },
        { id: 'ballad', name: 'Ballad (Warm, Engaging - Male)' },
        { id: 'coral', name: 'Coral (Friendly, Vibrant - Female)' },
        { id: 'echo', name: 'Echo (Warm, Conversational - Male)' },
        { id: 'fable', name: 'Fable (Expressive, British)' },
        { id: 'onyx', name: 'Onyx (Deep, Authoritative - Male)' },
        { id: 'nova', name: 'Nova (Energetic, Bright - Female)' },
        { id: 'sage', name: 'Sage (Calm, Natural - Female)' },
        { id: 'shimmer', name: 'Shimmer (Clear, Expressive - Female)' },
        { id: 'verse', name: 'Verse (Dynamic, Versatile)' },
        { id: 'marin', name: 'Marin (Natural, Conversational)' },
        { id: 'cedar', name: 'Cedar (Warm, Grounded)' }
      ],
      ultravoxVoices: [
        { voiceId:"7e53b695-8c13-4861-bfbc-ff521f4ebacb", name:"Saavi-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/ed9b05e6324c457685490352e9a1ec90/voices/H8bdWZHK2OgZwTN7ponr/jhoBXyhQgwLjuRW2h420.mp3" },
        { voiceId:"a0faeabe-3777-4846-9439-48d19f2bfc3e", name:"Tiago-Portuguese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/aQEa8IiClZhXpQdStTPijviqbf83/voices/NdHRjGnnDKGnnm2c19le/DdtTQHbdtg9OddTAXDrj.mp3" },
        { voiceId:"5d00d99b-7e89-4f5c-8103-2dea73cc38fe", name:"Paulo-Portuguese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/0E6B6ie19OUzDa7czZ3bI8JhtPg2/voices/aLFUti4k8YKvtQGXv0UO/WnPjbKRVPLGOhGpm1s47.mp3" },
        { voiceId:"f0ed7e07-0e85-4853-a8f5-e09c627cf944", name:"Cassidy-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/1da06ea679a54975ad96a2221fe6530d/voices/56AoDkrOh6qfVPDXZ7Pt/oEgVi6mikkKcpVcTFfj5.mp3" },
        { voiceId:"3a645332-ab59-485a-83ed-2fc0c79815f1", name:"David-English-British", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/BNgbHR0DNeZixGQVzloa/40VSLvxrLAkmQgyrEA4t.mp3" },
        { voiceId:"7bf77a8f-2ea8-4d0f-8d5f-cbac1271072a", name:"Alex-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/Qb19OyvHcRUcbBQGoxYEhoYKFmg1/voices/7ilYbYb99yBZGMUUKSaf/Kw9ZUUyoze8OyV2kmCPw.mp3" },
        { voiceId:"a0df06e1-d90a-444a-906a-b9c873796f4e", name:"Amrut-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/vO7hjeAjmsdlGgUdvPpe/OjCTOjpdxyFPInvFYrxB.mp3" },
        { voiceId:"ad69ddb2-363f-4279-adf4-5961f127ec2f", name:"Chinmay-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/514d94e9241c48e8b7905375729c436f/voices/xnx6sPTtvU635ocDt2j7/iWmWpwBvJNpwKr4KlYB8.mp3" },
        { voiceId:"d17917ec-fd98-4c50-8c83-052c575cbf3e", name:"Riya-Rao-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/514d94e9241c48e8b7905375729c436f/voices/wlmwDR77ptH6bKHZui0l/vDP823KvNyKcS3acBpIF.mp3" },
        { voiceId:"44504e63-59c5-4f69-9340-423231c79a03", name:"Anika-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/514d94e9241c48e8b7905375729c436f/voices/90ipbRoKi4CpHXvKVtl0/RHjv4PzQ8pTguUk1dcO5.mp3" },
        { voiceId:"5c66a578-7a4a-4bf9-b282-8c8a7ca3e6d8", name:"Mark-Slow", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/y7Wmp2r8nCeGkLiXiwMOVWktro13/voices/UgBBYS2sOqTuMpoF3BR0/0Oc7jiXwWN9kRTXfQsmw.mp3" },
        { voiceId:"2794bbac-088a-483d-9cfe-70b015fe6312", name:"Muyiwa-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/aWVr0Zx4tEZwT3m6ltdeg9KuhkA2/voices/r9DosIwaFvTjhC7gp1d2/c5fcef23-7c37-44e1-be0f-3960b29c11af.mp3" },
        { voiceId:"441ec053-5566-4d18-9752-452dd5120071", name:"Elilhiz-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/1da06ea679a54975ad96a2221fe6530d/voices/iehvjLbWf9WSnLRBuTuR/WkzpcUkOtqIXl0sdI6Mu.mp3" },
        { voiceId:"87edb04c-06d4-47c2-bd94-683bc47e8fbe", name:"Monika-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/514d94e9241c48e8b7905375729c436f/voices/2zRM7PkgwBPiau2jvVXc/NcEOQ9awTZvgwUoqtmU9.mp3" },
        { voiceId:"7c125579-a8b9-46ba-887b-60e4f0449e5d", name:"Raju-English-Indian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/514d94e9241c48e8b7905375729c436f/voices/3gsg3cxXyFLcGIfNbM6C/rGzUET9JqnvDlrj9gNqJ.mp3" },
        { voiceId:"e194185b-cb4e-43ab-9bef-e2a88530090d", name:"Francisco-Portuguese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/1da06ea679a54975ad96a2221fe6530d/voices/WsQeRzWJvoDvhPPJj5r7/2198749f-0444-4a8c-aba5-65d581483f86.mp3" },
        { voiceId:"e396a010-bede-4c56-972a-e8cb56aadda8", name:"Haytham-Arabic-Egyptian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/9QU6MqZNA2gQa3xJofEAkVetJtm1/voices/IES4nrmZdUBHByLBde0P/k0uwHjffW70gT6nJ9gW5.mp3" },
        { voiceId:"65de56b6-246b-434a-bbfd-d34f02fcd8e7", name:"Amr-Arabic-Egyptian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/LVILbN7mtsfs9r3lTkU2UDUd4IU2/voices/yrPIy5b3iLnVLIBfUSw8/a680bb99-93a3-4be7-b3ae-260cc8364072.mp3" },
        { voiceId:"905da14a-152e-45a1-a329-0bce2c37bcf2", name:"Flavia-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/hyvhDTDDzpYx6ESCEkdL0uGPv6H3/voices/kvVjNZvtnCv3Sl1Hr70T/xaOAjbXCjXCHUEjawQLD.mp3" },
        { voiceId:"74d331a7-36d3-4efb-b596-9ba381a0c5d5", name:"Carolina-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/UOIqAnmS11Reiei1Ytkc/iD8yOai01ygsrjOUknQ3.mp3" },
        { voiceId:"926ef3d0-686c-474a-8338-f64383eee5d1", name:"Miquel-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/pv9vptMMxjWAcpdePMY1CrUCtom1/voices/OYEoJbw85Qmdnfb8oB6K/102c0e22-713e-4bbe-96de-50f7bab32b20.mp3" },
        { voiceId:"325a57f4-6f8c-4b96-aa1c-cd0e4a541161", name:"Victor-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/5ZYfqUKaxNSA9elGT1r7akdx69d2/voices/6VhI0BBMzbLqzPaeqUCz/HeqclfQuDDruKYAFk79m.mp3" },
        { voiceId:"ecfa0ff5-55e1-45da-9646-5d6c6c780692", name:"Keren-Brazilian-Portuguese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/33B4UnXyTNbgLmdEDh5P/ArnzDsFaz6KDoDcDD8V2.mp3" },
        { voiceId:"a0998448-6810-4b44-bc90-ccb69d2a26f5", name:"Srivi - Tamil", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/workspace/ed9b05e6324c457685490352e9a1ec90/voices/eh0hAHy3N3C9DE0uyHHD/8sHbDp3HBtO8pWje0TmV.mp3" },
        { voiceId:"af750274-1a66-4b7c-ae41-e1a196fbe285", name:"Peter - Slovak", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/HOZrfHdrnpe9pZlWrIwZoq4cDsX2/voices/d6IbhdqAKkXCCVuJjbie/KdiAikWHzYiPnLKFP9Qv.mp3" },
        { voiceId:"3a312be1-29f0-4007-9ebf-7f7dcd6ba000", name:"Ciprian - Romanian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/XcKZk1UpVPb5ZeTOw7u8UC2wE3g2/voices/h3aQ5g69oxB0wpernpfx/c2f74f19-37c7-4646-8f6e-63b75ccecdc7.mp3" },
        { voiceId:"f3ded245-d53b-4bb9-b66e-f4bd214f2014", name:"Aurora - Finnish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/YnvMFnsOz1gXpFGFWbhHNkyNHho2/voices/YSabzCJMvEHDduIDMdwV/2kWo0RqG5nwi2Mc8dP23.mp3" },
        { voiceId:"028a1f66-250b-45fb-af2e-7e1ad8d1eef6", name:"Stefanos - Greek", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/sFRa14jQlVPYadW9ZSfUNemgxlt1/voices/czEPjbZ9jNJoQ7WzdyTa/6b772431-6b0b-4f02-b383-d13cdffe93eb.mp3" },
        { voiceId:"84db93a3-648c-4186-9bd6-c2177d5557d6", name:"Julian - Bulgarian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/kzrsjZhHCumKqmkJl486/crgXryf0iMhFkAUXiLJq.mp3" },
        { voiceId:"81aa0d14-5b80-486b-8661-140b6c5820f2", name:"Huyen - Vietnamese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/QFYxhWzSETeiPXYPPlCEN3lJcKr1/voices/foH7s9fX31wFFH2yqrFa/XEIsoRs7xArbmUx1pJpp.mp3" },
        { voiceId:"a6d71cd6-1204-4c8c-aabc-f679600cf0ae", name:"Trung Caha - Vietnamese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/y6fKTFEG7Ee17Z1zDZHoGFNsVKY2/voices/ueSxRO0nLF1bj93J2hVt/de4ac6e9-75d7-44c5-bb50-2305dfdda280.mp3" },
        { voiceId:"4c6a414f-34d5-4633-9d47-f25949554ca2", name:"Ramaa - Tamil", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/TLzQBQZ61wQrytFwliQpe4LeshE3/voices/ZhJ5LanYnCmLKQUXvsV7/pooiLHNeBUPpS20ZzL5O.mp3" },
        { voiceId:"6202538c-04b0-41cb-b0a0-3c862b683d4f", name:"Corina - Romanian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/gbLy9ep70G3JW53cTzFC/ORZ4ycrJb2N6RvCCndYi.mp3" },
        { voiceId:"c6b6e4dc-f15b-44ef-8679-97247a295725", name:"Magyar - Hungarian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/HOZrfHdrnpe9pZlWrIwZoq4cDsX2/voices/TumdjBNWanlT3ysvclWh/UtdbtjoD1JNS4TtqyzwM.mp3" },
        { voiceId:"4da4cd48-9abf-4005-9ffd-ca829128e6e5", name:"Christoffer - Finnish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/x5oDnHb3gcQVsz98Z9d02YR9nNq2/voices/3OArekHEkHv5XvmZirVD/26b3d232-c1b4-49f9-894d-e58a0b70b78f.mp3" },
        { voiceId:"3274a450-a199-4421-8b16-fdfa923ccf23", name:"Mathias - Danish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/ygiXC2Oa1BiHksD3WkJZ/MV8Filx4M2vlCNaIVYQH.mp3" },
        { voiceId:"d2d3f512-55a1-4e14-8322-1626efd1c531", name:"Denisa - Czech", previewUrl:"https://storage.googleapis.com/eleven-public-prod/7G095XVHsmgoCnhxJhLJeLZUzAR2/voices/OAAjJsQDvpg3sVjiLgyl/4cc64654-5542-4ff8-bfa7-67cf38c8c906.mp3" },
        { voiceId:"13b86f40-5ad9-4808-b9c3-c7f5419c95d5", name:"Adam - Czech", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/ZpYbCaSd2uMVjSr1tTgZPFLl0J92/voices/uYFJyGaibp4N2VwYQshk/P9QQG2a62C0lhe2HlcbL.mp3" },
        { voiceId:"bef461b7-d234-4d31-b09d-b6a101f7c79c", name:"Bea - Polish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/4BtkyC9Cwbfff8b19psbv3eeWIf1/voices/HnsghscV3PKM5tLCzch5/72f9eb2a-0ec0-42d0-8e8a-c0f0528c4ea2.mp3" },
        { voiceId:"49a97861-7bbb-486a-ba6f-6dec7f57b51d", name:"Pawel - Polish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/zzBTsLBFM6AOJtkr1e9b/jsLaAOqZnKHhKX1sJTWl.mp3" },
        { voiceId:"d082550b-596a-42f7-9356-840b4a095d3f", name:"Emma-Norwegian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/OSbmAb1GKjNVlChP2UgZukCicWR2/voices/b3jcIbyC3BSnaRu8avEk/bZ5dFORSQeyFBQ7VAv9C.mp3" },
        { voiceId:"864c6a02-ee99-47a1-b7d8-a723aa754bf4", name:"Johannes-Norwegian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/2dhHLsmg0MVma2t041qT/fX3l7ljt7bx6zRPz8VdC.mp3" },
        { voiceId:"bd2118e8-84fc-4d6f-8038-bb5e25e3f398", name:"linny" },
        { voiceId:"813f0a80-2dc5-4019-af72-11237a2b74d5", name:"Steve-English-Australian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/aGkVQvWUZi16EH8aZJvT/hUdpJvUH4knIjWwEeGyu.mp3" },
        { voiceId:"87691b77-0174-4808-b73c-30000b334e14", name:"Emily-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/G7iiSdUpTxfaEQrlPlp1/kbXLLTvxoQERU2r4oV2i.mp3" },
        { voiceId:"1769b283-36c6-4883-9c52-17bf75a29bc5", name:"Tanya-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/Bwff1jnzl1s94AEcntUq/qoI90uxNbUdjLpbz5RT4.mp3" },
        { voiceId:"feccf00b-417e-4e7a-9f89-62f537280334", name:"Aaron-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/ZzIzVo9ATCeBEsjfTWa17GTKTtn1/voices/D9Thk1W7FRMgiOhy3zVI/9fcf61b2-9948-4e11-a052-badce36b10ae.mp3" },
        { voiceId:"e6fce4ac-da54-43e9-8fb2-66de86f72a5b", name:"Conversationalist-English", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/FZXW5ux1H3cSnvGSZg5birHPYZ53/voices/RNnkVeW25AwKYxZgnHBH/03006bf3-bf0b-403e-8325-0e1652aef2d1.mp3" },
        { voiceId:"876ac038-08f0-4485-8b20-02b42bcf3416", name:"Hugo-French", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/CnqbtUuTI7c3c9tg8rabjLsxs392/voices/DbbNuBL7lf62XwY7arQb/SWJaCUjKugbzdtfB3K5g.mp3" },
        { voiceId:"b084d8f2-c9f9-491c-8059-d39dde80d58b", name:"Andrea-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/AUiOudcyrBgldqnAJhuGI9X0Ktn2/voices/qHkrJuifPpn95wK3rm2A/NWUHpjVjwbkaFDQy7fbX.mp3" },
        { voiceId:"e1c11ba4-034f-4354-b492-0460b7bbb20d", name:"Damian-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/f5KyudOMTbfPJNDbdODrSaS6spY2/voices/sdxJtmxpzgSLekrYUGIu/hkDBI9Ws0EEYbAWZh1no.mp3" },
        { voiceId:"33f2dab8-3836-4de2-985c-ef4928af64c9", name:"Muskaan-Hindi-Urdu", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/xoV6iGVuOGYHLWjXhVC7/HLJ6hooUJSQwgFVGM32b.mp3" },
        { voiceId:"ebae2397-0ba1-4222-9d5b-5313ddeb04b5", name:"Anjali-Hindi-Urdu", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/TLzQBQZ61wQrytFwliQpe4LeshE3/voices/gHu9GtaHOXcSqFTK06ux/pI2RQaKcueXaen7zO23a.mp3" },
        { voiceId:"9f6262e3-1b03-4a0b-9921-50b9cff66a43", name:"Krishna-Hindi-Urdu", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/TLzQBQZ61wQrytFwliQpe4LeshE3/voices/m5qndnI7u4OAdXhH0Mr5/3GqgqOGjRsluDRmsRcR7.mp3" },
        { voiceId:"da0cbd17-c6aa-4df7-b5eb-092e3f52eff8", name:"Cristina-Romanian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/KkG8t3G5s4Y95N21t0D1tGtWtkP2/voices/uRxQlQMA1BPSSdj5gXIK/a588aa70-47b2-4a5a-a8d1-e5a117b71f59.mp3" },
        { voiceId:"9815a9f0-ed7e-4d0b-9ace-dba62efcf658", name:"Antonia-Romanian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/3z9q8Y7plHbvhDZehEII/RizL5Q4u5cwB0Qrp02so.mp3" },
        { voiceId:"9d7bc57b-2e1c-4622-acb7-39c4f32dacfb", name:"Salma-Arabic", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/TLzQBQZ61wQrytFwliQpe4LeshE3/voices/aCChyB4P5WEomwRsOKRh/pwNKTCc35h8TdZeZNkAR.mp3" },
        { voiceId:"73a8f736-e97e-4284-8a5b-9649eec6152c", name:"Raed-Arabic", previewUrl:"https://storage.googleapis.com/eleven-public-prod/2IWzWT3G3sgilYJywwA1YhbUxU73/voices/IK7YYZcSpmlkjKrQxbSn/23430e54-d41e-4b40-b321-9e5a9f3018b4.mp3" },
        { voiceId:"03ed40bf-90c7-42f3-becd-79fc816bbd84", name:"Ben-German", previewUrl:"https://storage.googleapis.com/eleven-public-prod/eGBxkfZBbNQjuI5DNbmSnnQpWab2/voices/aTTiK3YzK3dXETpuDE2h/361f0e9a-f91f-4003-a6d5-249f6935671b.mp3" },
        { voiceId:"806d4bad-38ed-49fd-91c8-e8aaa324c75e", name:"Frida - German", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/Ugu0tUnhweQjZLi9GZUX14rN1JG3/voices/PmkWuBgfgyHPLOeC499E/xpgyCdFNTFDg7Ce8PENZ.mp3" },
        { voiceId:"885ac23b-883d-484a-b920-082f73dfec62", name:"Marcin-Polish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/JYKwbpTKxJXlJFd9CIZju6u73Ae2/voices/MXt9WArfiuiT7MmD6D61/60b10320-08e9-4958-8f1e-1b191af6d8fc.mp3" },
        { voiceId:"9eb6a57b-e9b4-435c-8284-25f5d9594879", name:"Hanna-Polish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/OL55YKALeab7lyIfDKwe0l2b1bR2/voices/NacdHGUYR1k3M0FAbAia/d10ba6a4-e6b5-4ee6-b604-f68b5c2baa76.mp3" },
        { voiceId:"ac329809-3b43-4ab7-a16a-b40448212e1c", name:"Dakota Flash V2", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/P7x743VjyZEOihNNygQ9/IrAuSVGhpFcocJNZ4U0i.mp3" },
        { voiceId:"d5374ad9-8582-49da-84d6-78eb13e361af", name:"Coco-French", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/koOonD4HAsSMVyHuP4QTaatQ9cA2/voices/MNiuKciqE420DCRJtdeb/71sD4WwmJjJM2b4oMC10.mp3" },
        { voiceId:"216a9c86-06c2-416b-a03b-9884a57e6b4c", name:"Gabriel-French", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/PBm6YPbx7WbrxFTZwj3E/D8U7C2MgPxZt3MVgeFjn.mp3" },
        { voiceId:"e5c005d4-359d-4d25-b6ad-ab09ad8947f5", name:"Daniel-Dutch", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/UdwnkJaZxPCOeR3qITvA/2VfTAXu5u34vODRFiSEp.mp3" },
        { voiceId:"54ebeae1-88df-4d66-af13-6c41283b4332", name:"Chelsea", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/lT3exDSBW2XZ2SflZO48glfmDYE3/voices/NHRgOEwqx5WZNClv5sat/L1sWGVhCp2gf1PzyhaAb.mp3" },
        { voiceId:"563d27d1-ca1d-4aec-bed9-5e04f690c465", name:"Vira-Ukrainian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/mGLUsH9ra4W6rflL9dtShIY2uUu2/voices/nCqaTnIbLdME87OuQaZY/lqEI9lFRXrUWBhRpXvJb.mp3" },
        { voiceId:"d0a129d4-e5d8-4cca-8486-69cc15b328f5", name:"Dmytro-Ukrainian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/ElvE0cxMRNTJf8mJVdkEIT03v4j2/voices/NJGiMgVHtXSA1XYSuNKl/7fcf9ee6-b16a-41ec-b462-a1f41d6c5d5d.mp3" },
        { voiceId:"68b87c10-3016-4607-9084-a4d5361e2507", name:"Cicek-Turkish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/Gp7macCqIbcDzuRHmrksJ4SdQH02/voices/EJGs6dWlD5VrB3llhBqB/szhfZFAxWkMVrrhwqt5s.mp3" },
        { voiceId:"56db7055-b0cc-428c-9a12-eda90e3f671f", name:"Doga-Turkish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/MGfltzGx2ufKbE2Khgf8i9Ud57p2/voices/IuRRIAcbQK5AQk1XevPj/A7zA5q6bsat2zGTgUIHM.mp3" },
        { voiceId:"f94d6f04-df7b-48e7-85a5-a21f4b5856d5", name:"Tatiana-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/8RYUsFHsalUXjwVG0LjhNwH1j022/voices/2rigMbVWLdqtBSCahJFX/h42L452UXdOFeirGlerd.mp3" },
        { voiceId:"806d5c1e-b5ae-46c8-8719-04f1bc67c0a3", name:"Mauricio-Spanish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/aMFLZudGpbVyEMAcpCuGoohryKG2/voices/94zOad0g7T7K4oa7zhDq/18baea3b-d7ee-4863-994b-ac3f59315999.mp3" },
        { voiceId:"9303a29e-578a-4953-a927-2e1921683d27", name:"Felix-Russian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/sRk0zCqhS2Cmv0bzx5wA/KWEN9Hb1bwDUDrwPLeG3.mp3" },
        { voiceId:"2e6148f5-4c06-49db-8fa5-57bc30b31eeb", name:"Rosa-Portuguese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/UfR91GZFReU9KE7HWeOrpPEKpG73/voices/cyD08lEy76q03ER1jZ7y/4cb10850-1932-48bf-a88d-600839c19c80.mp3" },
        { voiceId:"0644f584-9ce3-4957-99dc-98fa29a63075", name:"Samuel-Portuguese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/fiN6pMGfa8NSQWjlei57Ncv7p7s1/voices/ETf5cmpNIbpSiXmBaR2m/19e57542-4215-464d-8a46-0c59255d408d.mp3" },
        { voiceId:"ae8735c7-ba49-46ac-915f-3751e89f0db3", name:"Morioki-Japanese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/MwVnKyOTE3ZRdpgHUo84p20s9zw2/voices/8EkOjt4xTPGMclNlh1pk/09bd3d5e-755b-4046-8ace-c69f0dcc872f.mp3" },
        { voiceId:"0985443f-644b-47a5-942a-39b2daf230fd", name:"Asahi-Japanese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/GKDaBI8TKSBJVhsCLD6n/kRQ5Gg7mqjJLf0Dary2z.mp3" },
        { voiceId:"a8244028-72c3-4ae6-9fbe-3ad3da168dda", name:"Nadia-Russian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/gedzfqL7OGdPbwm0ynTP/w3TZGiSgIypkSFp0lr0Q.mp3" },
        { voiceId:"ee16d0ab-a1fe-4ff1-a63c-3ad8a0fdee8a", name:"Linda-Italian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/3DPhHWXDY263XJ1d2EPN/YcN8v5oIOX09iQfWoPXH.mp3" },
        { voiceId:"19f7e0c8-332b-4ff3-b33c-18a17290bcc7", name:"Giovanni-Italian", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/fzDFBB4mgvMlL36gPXcz/9mWvFKGio04aGXSm7tbQ.mp3" },
        { voiceId:"c2c5cce4-72ec-4d8b-8cdb-f8a0f6610bd1", name:"Riya-Hindi-Urdu", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/mActWQg9kibLro6Z2ouY/MUOtsgIuvSnfDxBuzdjY.mp3" },
        { voiceId:"82c9728c-e0fe-4bc2-b7a3-03bb271fafb9", name:"Aakash-Hindi", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/TLzQBQZ61wQrytFwliQpe4LeshE3/voices/Uyx98Ek4uMNmWN7E28CD/0Jj8GgmExU0pTp8xzybh.mp3" },
        { voiceId:"0191cf63-44b7-4277-bffe-be2f5dcc950c", name:"Susi-German", previewUrl:"https://storage.googleapis.com/eleven-public-prod/1KI0h0RJuscE0Ta9tVvydENJ9JF3/voices/v3V1d2rk6528UrLKRuy8/8aab3a1d-2faf-4de4-b229-f3a2ebb21c43.mp3" },
        { voiceId:"ab4eaa72-5cf3-40c1-a921-bca62a884bb4", name:"Alize-French", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/koOonD4HAsSMVyHuP4QTaatQ9cA2/voices/MNKK2Wl2wbbsEPQTHZGt/LySJ82yLzuh7DjEQT5yG.mp3" },
        { voiceId:"6dedd91b-63a0-4e46-87ec-10ec36c2fffb", name:"Nicolas-French", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/ajGQb2hVVXdBWWu6HHJEkWasByJ3/voices/aQROLel5sQbj1vuIVi6B/gBM2dEXvQpEXbDwLodAU.mp3" },
        { voiceId:"5a1e2cc2-f447-4c24-81fe-4a1951f2c5d0", name:"Ruth-Dutch", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/YUdpWWny7k5yb4QCeweX/JSQ3bguKNWB0Mfhn18Ka.mp3" },
        { voiceId:"1f5b5818-8797-44fd-8ce6-2cd20d41bd1d", name:"Sana-Arabic", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/k3cwQyUC1jgnRz4wTDCaJg9CSPj2/voices/tavIIPLplRB883FzWU0V/DWgPLUhwxtXvzQXVDAyk.mp3" },
        { voiceId:"7973800a-ebd5-4756-a211-d609c66e1b8f", name:"HerrGruber-German", previewUrl:"https://storage.googleapis.com/eleven-public-prod/GtmMih8Uc3gyDcO0MxuBXqKvLaX2/voices/J5U94vRbS9drxnawJcoc/79957411-9728-4881-8336-88043da5beaa.mp3" },
        { voiceId:"cd617a9a-8ce8-4b44-8306-300b6e55c0f3", name:"Sanna-Swedish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/4xkUqaR9MYOJHoaC1Nak/l4PwfhXHwvKzA0G9XP46.mp3" },
        { voiceId:"90dbf12f-9cb0-4da0-b51f-ad2d4c5d9995", name:"Adam-Swedish", previewUrl:"https://storage.googleapis.com/eleven-public-prod/Clk6kdJ10yNzb14pOOqXKi1y5qW2/voices/x0u3EW21dbrORJzOq1m9/ffda0752-26f1-4341-8f31-161771679941.mp3" },
        { voiceId:"508ad0ba-8fca-4633-8efb-da16af6976ec", name:"Anas-Arabic", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/COWGBw0EVLcZa92K5IDgvpaUttd2/voices/R6nda3uM038xEEKi7GFl/hyjPYHgaCHfuSSap6ALl.mp3" },
        { voiceId:"c7725456-7cf3-4cb1-88c0-45c1ef7e6111", name:"Martin-Chinese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/custom/voices/WuLq5z7nEcrhppO0ZQJw/VQoMkMi8aSXSAwz6NHzh.mp3" },
        { voiceId:"3abe60f5-13ed-4e82-ac15-4391d9e5cd9d", name:"Oliver", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/T7bhqxLyENgRaSgfnqhPa6vPSID2/voices/L1aJrPa7pLJEyYlh3Ilq/AwAwPn2G1wujoh4o4RGM.mp3" },
        { voiceId:"8b79b46f-3b1c-4280-9521-2cac1b6eabd5", name:"Maya-Chinese", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/9axODppOpDadFfxEDFYygFROdkh2/voices/GgmlugwQ4LYXBbEXENWm/AP0YhlW1zVxV5sXFTGF3.mp3" },
        { voiceId:"b0e6b5c1-3100-44d5-8578-9015aa3023ae", name:"Jessica", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/yA8yDNUx4dZ4gwL9ztbTpUEIyR12/voices/g6xIsTj2HwM6VR4iXFCw/lATTwqV2Uqz9NmNtMCfO.mp3" },
        { voiceId:"91fa9bcf-93c8-467c-8b29-973720e3f167", name:"Mark", previewUrl:"https://storage.googleapis.com/eleven-public-prod/database/user/y7Wmp2r8nCeGkLiXiwMOVWktro13/voices/UgBBYS2sOqTuMpoF3BR0/0Oc7jiXwWN9kRTXfQsmw.mp3" }
      ]
    }
  },
  computed: {
    ...mapState({
      me: state => state.me.me,
      profile: state => state.me.profile
    }),
    currentDurationOptions () {
      const selectedId = this.activeSetting ? this.activeSetting.selected_ghl_calendar_id : null;
      if (!selectedId) return [];
      const selected = this.serviceOptions.find(item => item.id === selectedId);
      return selected ? (selected.durationOptions || []) : [];
    },
    activeSetting() {
      if (this.me && this.me.integrations && this.me.integrations.bland && this.me.integrations.bland.settings) {
        const setting = this.me.integrations.bland.settings[this.selected_bland_number];
        if (setting) {
          if (!setting.voice_source) this.$set(setting, 'voice_source', 'retell');
          if (!setting.retell_speech_settings) {
            this.$set(setting, 'retell_speech_settings', {
              ambient_sound: null,
              responsiveness: 0.95,
              enable_dynamic_responsiveness: false,
              interruption_sensitivity: 0.93,
              reminder_trigger_ms: 10000,
              reminder_max_count: 1,
              pronunciation_dictionary: [],
              enable_backchannel: false,
              backchannel_frequency: 0.8,
              backchannel_words: "",
              normalize_for_speech: true
            });
          }
          if (!setting.retell_call_settings) {
            this.$set(setting, 'retell_call_settings', {
              enable_voicemail_detection: false,
              voicemail_message: "",
              voicemail_detection_timeout_ms: 30000,
              opt_out_sensitive_data_storage: false,
              allow_user_dtmf: false,
              user_dtmf_options: { timeout_ms: 2500, termination_key: "#", digit_limit: 10 },
              end_call_after_silence_ms: 60000,
              max_call_duration_ms: 420000,
              ring_duration_ms: 30000
            });
          }
          if (!setting.retell_voice_model) {
            this.$set(setting, 'retell_voice_model', {
              model: 'eleven_turbo_v2',
              voice_speed: 1.0,
              voice_temperature: 1.0,
              volume: 1.0
            });
          }
          if (!setting.retell_transfer) {
            this.$set(setting, 'retell_transfer', {
              description: '',
              transfer_type: 'cold',
              displayed_phone_number: 'retell',
              transfer_destination: { type: 'predefined', number: '', prompt: '' },
              warm_transfer_option: { type: 'prompt', prompt: '', message: '', debrief_mode: 'whisper' }
            });
          } else if (setting.retell_transfer.warm_transfer_option && !setting.retell_transfer.warm_transfer_option.debrief_mode) {
            this.$set(setting.retell_transfer.warm_transfer_option, 'debrief_mode', 'whisper');
          }
          if (!setting.retell_llm_settings) {
            this.$set(setting, 'retell_llm_settings', {
              model_temperature: 0.7,
              tool_call_strict_mode: false,
              model_high_priority: false,
              calendar_enabled: false
            });
          }
          if (!setting.knowledgebase_files) this.$set(setting, 'knowledgebase_files', []);
          if (!setting.knowledgebase_websites) this.$set(setting, 'knowledgebase_websites', []);
          if (!setting.openai_model) this.$set(setting, 'openai_model', 'gpt-live-1');
          if (!setting.openai_voice) this.$set(setting, 'openai_voice', 'coral');
        }
        return setting;
      }
      return null;
    },
    // Pure JS Myers LCS word diff comparing selected version against its predecessor
    promptDiffParts() {
      const newText = (this.activeSetting && this.activeSetting.call_prompt) ? this.activeSetting.call_prompt : '';
      const oldText = this.lastSavedPrompt || '';

      if (!oldText && !newText) return [];
      if (oldText === newText) {
        return [{ value: newText, added: false, removed: false }];
      }

      const tokenize = (str) => str.match(/\S+|\s+/g) || [];
      const a = tokenize(oldText);
      const b = tokenize(newText);

      const N = a.length;
      const M = b.length;

      const L = Array.from({ length: N + 1 }, () => new Int32Array(M + 1));
      for (let i = N - 1; i >= 0; i--) {
        for (let j = M - 1; j >= 0; j--) {
          if (a[i] === b[j]) {
            L[i][j] = L[i + 1][j + 1] + 1;
          } else {
            L[i][j] = Math.max(L[i + 1][j], L[i][j + 1]);
          }
        }
      }

      const diff = [];
      let i = 0, j = 0;
      while (i < N && j < M) {
        if (a[i] === b[j]) {
          diff.push({ value: a[i], added: false, removed: false });
          i++;
          j++;
        } else if (L[i + 1][j] >= L[i][j + 1]) {
          diff.push({ value: a[i], added: false, removed: true });
          i++;
        } else {
          diff.push({ value: b[j], added: true, removed: false });
          j++;
        }
      }

      while (i < N) {
        diff.push({ value: a[i], added: false, removed: true });
        i++;
      }
      while (j < M) {
        diff.push({ value: b[j], added: true, removed: false });
        j++;
      }

      return diff;
    }
  },
  methods: {
    phoneSource,
    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    },
    async fetchVersions(autoSelectId = null) {
      if (!this.activeSetting || !this.activeSetting.phone_number) return;
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}/agency/prompt-versions?phone_number=${encodeURIComponent(this.activeSetting.phone_number)}`,
          { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } }
        );
        const fetched = response.data.versions || [];

        if (fetched.length > 0) {
          this.promptVersions = fetched;

          // Select specified version ID, active version, or newest version
          let target = null;
          if (autoSelectId) {
            target = this.promptVersions.find(v => v.id === autoSelectId);
          }
          if (!target) {
            target = this.promptVersions.find(v => v.is_active) || this.promptVersions[0];
          }

          this.selectedVersionId = target.id;
          
          // Find preceding version for relative diff comparison
          const currIndex = this.promptVersions.findIndex(v => v.id === target.id);
          const previousVer = this.promptVersions[currIndex + 1];
          this.lastSavedPrompt = previousVer ? previousVer.call_prompt : '';
        } else {
          // Default Fallback: Show Version 0 when no records exist
          const defaultV0 = {
            id: 'v0-default',
            version_number: 0,
            call_prompt: this.activeSetting.call_prompt || '',
            sms_prompt: this.activeSetting.sms_prompt || '',
            created_at: new Date().toISOString(),
            is_active: true
          };
          this.promptVersions = [defaultV0];
          this.selectedVersionId = 'v0-default';
          this.lastSavedPrompt = '';
        }
      } catch (e) {
        console.error('Failed to fetch prompt versions', e);
        const defaultV0 = {
          id: 'v0-default',
          version_number: 0,
          call_prompt: this.activeSetting.call_prompt || '',
          sms_prompt: this.activeSetting.sms_prompt || '',
          created_at: new Date().toISOString(),
          is_active: true
        };
        this.promptVersions = [defaultV0];
        this.selectedVersionId = 'v0-default';
        this.lastSavedPrompt = '';
      }
    },
    async onVersionChange() {
      const version = this.promptVersions.find(v => v.id === this.selectedVersionId);
      if (!version) return;

      this.activeSetting.call_prompt = version.call_prompt;
      if (version.sms_prompt) {
        this.activeSetting.sms_prompt = version.sms_prompt;
      }

      // Compute diff relative to the previous version in history
      const currIndex = this.promptVersions.findIndex(v => v.id === version.id);
      const previousVer = this.promptVersions[currIndex + 1];
      this.lastSavedPrompt = previousVer ? previousVer.call_prompt : '';

      if (version.id !== 'v0-default') {
        try {
          await axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/agency/prompt-versions/use`,
            { phone_number: this.activeSetting.phone_number, version_id: version.id },
            { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } }
          );
        } catch (e) {
          console.error('Failed to switch version', e);
        }
      }
    },
    async generatePromptChange() {
      if (!this.promptChangeDescription.trim() || !this.activeSetting) return;

      this.revisingPrompt = true;
      try {
        const payload = {
          bad_response: '',
          issue_description: this.promptChangeDescription,
          phone_number: this.activeSetting.phone_number
        };
        const response = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/agency/prompt-builder/revise`,
          payload,
          { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } }
        );

        if (response.data.success) {
          this.activeSetting.call_prompt = response.data.revised_prompt;
          this.promptChangeDescription = '';
          
          // Auto save generated prompt to register new version in DB and refresh dropdown
          await this.saveBlandSettings(true);
        } else {
          alert(response.data.error || 'Failed to generate updated prompt');
        }
      } catch (e) {
        console.error(e);
        alert('Error connecting to prompt optimizer assistant.');
      } finally {
        this.revisingPrompt = false;
      }
    },
    async runTesterMessage() {
      if (!this.testerInput.trim() || !this.activeSetting) return;

      const userMsg = this.testerInput.trim();
      this.testerMessages.push({ role: 'user', content: userMsg });
      this.testerInput = '';
      this.testingPrompt = true;

      try {
        const response = await axios.post('https://ai.revulsab.com/get-response', {
          messages: this.testerMessages,
          prompt: this.activeSetting.call_prompt,
          u: this.me.uuid
        });

        this.testerMessages.push({
          role: 'assistant',
          content: response.data.message || 'No response returned.'
        });
      } catch (e) {
        console.error(e);
        this.testerMessages.push({
          role: 'assistant',
          content: 'Error generating response from test engine.'
        });
      } finally {
        this.testingPrompt = false;
      }
    },
    resetTesterChat() {
      this.testerMessages = [];
    },
    onCopyAiNumber() {
      this.$swal({ title: "Copied", text: "Phone number copied successfully!", showCancelButton: false });
    },
    onErrorAiNumber(e) {
      alert('Failed to copy phone number');
      console.log(e);
    },
    onElevenVoiceChange({ id, name, previewUrl }) {
      if (this.activeSetting) {
        this.activeSetting.voice_elevenlabs_id = id;
        this.activeSetting.voice_elevenlabs_name = name;
        this.activeSetting.voice_elevenlabs_preview_url = previewUrl;
      }
    },
    async fetchRetellVoices() {
      try {
        const response = await fetch('https://api.retellai.com/list-voices', {
          headers: {
            Authorization: 'Bearer key_76de52525950c499884ec1580872',
            'Content-Type': 'application/json'
          }
        });
        const data = await response.json();
        this.retellVoices = data || [];
      } catch (error) {
        console.error('Failed to fetch voices:', error);
      }
    },
    toArray (maybe) {
      if (Array.isArray(maybe)) return maybe
      if (!maybe) return []
      if (Array.isArray(maybe.data)) return maybe.data
      if (typeof maybe === 'string') {
        try { const p = JSON.parse(maybe); return Array.isArray(p) ? p : [] } catch (e) { return [] }
      }
      if (typeof maybe === 'object') return Object.values(maybe)
      return []
    },
    async getGhlCalendars () {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}/agency/get-ghl-calendars`,
          { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } }
        )
        const teams = Array.isArray(data) ? data : (Array.isArray(data.calendars) ? data.calendars : [])
        const items = []
        
        teams.forEach(team => {
          items.push({ header: team.calendarConfig.description })
          
          this.toArray(team.services).forEach(svc => {
            items.push({ 
              id: svc.id, 
              name: svc.name, 
              teamId: team.id, 
              teamName: team.name,
              durationOptions: svc.durationOptions || []
            })
          })

          items.push({ divider: true })
        })
        
        if (items.length && items[items.length - 1].divider) items.pop()
        this.serviceOptions = items
      } catch (e) {
        this.serviceOptions = []
      }
    },
    onCalendarChange(selectedId) {
      const selectedService = this.serviceOptions.find(item => item.id === selectedId)
      
      if (selectedService && selectedService.durationOptions && selectedService.durationOptions.length) {
        const defaultOption = selectedService.durationOptions.find(opt => opt.isDefault) 
                              || selectedService.durationOptions[0]
        
        this.activeSetting.selected_ghl_duration_option = defaultOption
      } else {
        this.activeSetting.selected_ghl_duration_option = null
      }
    },
    getIdFromBlandNumberSelect() {
      if (this.blandNumberSelected && this.me.integrations.bland.settings) {
        this.selected_bland_number = this.me.integrations.bland.settings.findIndex(
          x => x.phone_number === this.blandNumberSelected.phone_number
        );
        this.fetchVersions();
      }
    },
    addPronunciation() {
      if (this.newPronunciationWord.trim() && this.activeSetting) {
        this.activeSetting.retell_speech_settings.pronunciation_dictionary.push({
          word: this.newPronunciationWord.trim(),
          alphabet: 'ipa',
          phoneme: ''
        });
        this.newPronunciationWord = '';
      }
    },
    removePronunciation(idx) {
      if (this.activeSetting) {
        this.activeSetting.retell_speech_settings.pronunciation_dictionary.splice(idx, 1);
      }
    },
    deleteKnowledgebaseFile(index) {
      if (this.activeSetting) {
        this.activeSetting.knowledgebase_files.splice(index, 1);
      }
    },
    deleteKnowledgebaseWebsite(index) {
      if (this.activeSetting) {
        this.activeSetting.knowledgebase_websites.splice(index, 1);
      }
    },
    getChatWidgetPages() {
      if (!this.activeSetting) return [];
      if (!Array.isArray(this.activeSetting.chat_widget_pages)) {
        this.$set(this.activeSetting, 'chat_widget_pages', []);
      }
      return this.activeSetting.chat_widget_pages;
    },
    addChatWidgetPage() {
      const pages = this.getChatWidgetPages();
      pages.push({ page: '', prompt: this.activeSetting ? this.activeSetting.call_prompt : '' });
    },
    removeChatWidgetPage(index) {
      const pages = this.getChatWidgetPages();
      pages.splice(index, 1);
    },
    async onUploadKnowledgebase() {
      if (this.knowledgebase_file !== null && this.activeSetting) {
        this.uploading_knowledgebase = true;
        let formData = new FormData();
        for (var i in this.knowledgebase_file) {
          formData.append("file[" + i + "]", this.knowledgebase_file[i]);
        }
        formData.append('phone_number', this.activeSetting.phone_number);

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/inbox/upload-knowledgebase`, formData, {
            headers: { 'Authorization': 'Bearer ' + this.$store.state.auth.jwt }
          });
          this.me.integrations.bland.settings = response.data.settings;
        } catch(e) {
          console.error(e);
        }
        this.knowledgebase_file = null;
        this.uploading_knowledgebase = false;
      }
    },
    playVoiceRetell() {
      let preview_audio_url = "";
      for (var i in this.retellVoices) {
        if (this.retellVoices[i].voice_id == this.activeSetting.voice_retell) {
          preview_audio_url = this.retellVoices[i].preview_audio_url;
        }
      }
      if (!preview_audio_url) return;

      this.playingVoice = true;
      const ctx = new AudioContext();
      fetch(preview_audio_url)
        .then(data => data.arrayBuffer())
        .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
        .then(decodedAudio => {
          let playSound = ctx.createBufferSource();
          playSound.buffer = decodedAudio;
          playSound.connect(ctx.destination);
          playSound.start(ctx.currentTime);
          this.playingVoice = false;
        }).catch(() => { this.playingVoice = false; });
    },
    playVoiceUltravox() {
      let preview_audio_url = "";
      for (var i in this.ultravoxVoices) {
        if (this.ultravoxVoices[i].voiceId == this.activeSetting.voice_ultravox) {
          preview_audio_url = this.ultravoxVoices[i].previewUrl;
        }
      }
      if (!preview_audio_url) return;

      this.playingVoice = true;
      const ctx = new AudioContext();
      fetch(preview_audio_url)
        .then(data => data.arrayBuffer())
        .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
        .then(decodedAudio => {
          let playSound = ctx.createBufferSource();
          playSound.buffer = decodedAudio;
          playSound.connect(ctx.destination);
          playSound.start(ctx.currentTime);
          this.playingVoice = false;
        }).catch(() => { this.playingVoice = false; });
    },
    async playVoiceVertex() {
      this.playingVoice = true;
      try {
        const response = await fetch('https://aiv2.revulsab.com/preview-voice', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ voice: this.activeSetting.voice_vertex }),
        });
        const blob = await response.blob();
        const audioUrl = URL.createObjectURL(blob);
        const audio = new Audio(audioUrl);
        audio.play();
        audio.onended = () => {
          URL.revokeObjectURL(audioUrl);
          this.playingVoice = false;
        };
      } catch (err) {
        this.playingVoice = false;
      }
    },
    async playVoiceOpenAI() {
      this.playingVoice = true;
      try {
        const response = await fetch('https://aiv2.revulsab.com/preview-voice', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ voice: this.activeSetting.openai_voice || 'coral', provider: 'openai' }),
        });
        const blob = await response.blob();
        const audioUrl = URL.createObjectURL(blob);
        const audio = new Audio(audioUrl);
        audio.play();
        audio.onended = () => {
          URL.revokeObjectURL(audioUrl);
          this.playingVoice = false;
        };
      } catch (err) {
        this.playingVoice = false;
      }
    },
    playVoiceElevenlabs() {
      let preview_audio_url = this.activeSetting.voice_elevenlabs_preview_url;
      if (!preview_audio_url) return;

      this.playingVoice = true;
      const ctx = new AudioContext();
      fetch(preview_audio_url)
        .then(data => data.arrayBuffer())
        .then(arrayBuffer => ctx.decodeAudioData(arrayBuffer))
        .then(decodedAudio => {
          let playSound = ctx.createBufferSource();
          playSound.buffer = decodedAudio;
          playSound.connect(ctx.destination);
          playSound.start(ctx.currentTime);
          this.playingVoice = false;
        }).catch(() => { this.playingVoice = false; });
    },
    voiceChatWidgetUrl() {
      if (!this.activeSetting) return '';
      return "https://demo.diyai.ai/?showUserTranscripts=true&title=" + encodeURIComponent(this.activeSetting.voice_widget_title || '')
            + "&textColor=" + encodeURIComponent(this.activeSetting.voice_widget_text_color || '')
            + "&bgColor=" + encodeURIComponent(this.activeSetting.voice_widget_box_color || '')
            + "&btnTalkColor=" + encodeURIComponent(this.activeSetting.voice_widget_talk_button_color || '')
            + "&btnMuteColor=" + encodeURIComponent(this.activeSetting.voice_widget_mute_button_color || '')
            + "&btnEndColor=" + encodeURIComponent(this.activeSetting.voice_widget_end_button_color || '')
            + "&u=" + this.me.uuid
            + "&p=" + encodeURIComponent(this.activeSetting.phone_number || '');
    },
    reloadVoiceWidget() {
      this.voiceChatWidgetKey++;
    },
    getVoiceEmbedCode() {
      return `<iframe src="${this.voiceChatWidgetUrl()}" style="width: 100%; height: 500px; border-radius: 10px; border: solid 1px #CCCCCC; position: relative; overflow: hidden; display: block; margin: 0 auto;" allow="microphone"></iframe>`;
    },
    getEmbedCode() {
      return `<style>
iframe#acc-lsa-widget { width: 100%; height: 100%; min-height: 500px; border: solid 1px #CCCCCC !important; }
@media (max-width: 768px) { iframe#acc-lsa-widget { height: 60vh; min-height: 59vh; } }
</style> </head> <body>
<iframe id="acc-lsa-widget" src="${window.location.origin}/chat?u=${this.me.uuid}&p=${this.activeSetting ? encodeURIComponent(this.activeSetting.phone_number) : ''}"></iframe>`;
    },
    getEmbedCodeFloating() {
      return `<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@mdi/font@latest/css/materialdesignicons.min.css">
<style>
iframe#acc-lsa-widget { display: none; width: 450px; height: 550px; border: solid 1px #CCCCCC !important; position: fixed; right: 0px; bottom: 0px; margin-right: 15px; margin-bottom: 90px;z-index: 9999999999; }
@media (max-width: 768px) { iframe#acc-lsa-widget { width: 94%; height: 550px; } }
.ls-floating-button {border-radius: 10px;background: #3a9bdb;position: fixed;z-index: 9999999999;right: 0px;bottom: 0px;margin-right: 15px;margin-bottom: 15px;width: 60px;height: 46px;text-align: center;line-height: 50px;cursor: pointer;}
.ls-floating-button.close {display: none;color: #FFFFFF; font-size: 20px; height: 49px;}
</style>
<iframe id="acc-lsa-widget" src="${window.location.origin}/chat?u=${this.me.uuid}&p=${this.activeSetting ? encodeURIComponent(this.activeSetting.phone_number) : ''}&fl=1"></iframe>
<div class="ls-floating-button" onclick="document.getElementById('ls-floating-bubble').style.display = 'none'; document.querySelector('.ls-floating-button').style.display = 'none'; document.querySelector('.ls-floating-button.close').style.display = 'block'; document.querySelector('#acc-lsa-widget').style.display = 'block';"><i class="mdi mdi-message-text-outline" style="font-size: 30px; color: #FFFFFF;"></i></div>
<div class="ls-floating-button close" onclick="document.querySelector('.ls-floating-button').style.display = 'block'; document.querySelector('.ls-floating-button.close').style.display = 'none'; document.querySelector('#acc-lsa-widget').style.display = 'none';"><i class="mdi mdi-close" style="font-size: 35px; color: #FFFFFF;"></i></div>`;
    },
    async saveBlandSettings(silent = false) {
      this.savingBland = true;
      this.errorBland = null;

      let params = {
        api_key: this.me.integrations.bland.settings.api_key,
        phone_number_to_update: this.activeSetting.phone_number,
        label: this.activeSetting.label,
        call_prompt: this.activeSetting.call_prompt,
        separate_sms_prompt: this.activeSetting.separate_sms_prompt,
        sms_prompt: this.activeSetting.sms_prompt,
        gmail_prompt: this.activeSetting.gmail_prompt,
        voice_settings: this.activeSetting.voice_settings,
        temperature: this.activeSetting.temperature,
        voice: this.activeSetting.voice,
        voice_source: this.activeSetting.voice_source,
        voice_retell: this.activeSetting.voice_retell,
        retell_model: this.activeSetting.retell_model,
        voice_ultravox: this.activeSetting.voice_ultravox,
        ultravox_model: this.activeSetting.ultravox_model,
        voice_elevenlabs_id: this.activeSetting.voice_elevenlabs_id,
        voice_elevenlabs_name: this.activeSetting.voice_elevenlabs_name,
        voice_elevenlabs_preview_url: this.activeSetting.voice_elevenlabs_preview_url,
        elevenlabs_model: this.activeSetting.elevenlabs_model,
        voice_vertex: this.activeSetting.voice_vertex,
        openai_voice: this.activeSetting.openai_voice,
        openai_model: this.activeSetting.openai_model,
        model: this.activeSetting.model,
        business_phone_number: this.activeSetting.business_phone_number,
        calendar_link: this.activeSetting.calendar_link,
        calendar_enabled: this.activeSetting.calendar_enabled,
        calendar_type: this.activeSetting.calendar_type,
        selected_ghl_calendar_id: this.activeSetting.selected_ghl_calendar_id,
        selected_ghl_duration_option: this.activeSetting.selected_ghl_duration_option,
        book_what: this.activeSetting.book_what,
        auto_request_reviews: this.activeSetting.auto_request_reviews,
        auto_request_reviews_delay: this.activeSetting.auto_request_reviews_delay,
        auto_request_reviews_sms: this.activeSetting.auto_request_reviews_sms,
        auto_request_reviews_email: this.activeSetting.auto_request_reviews_email,
        review_email_subject: this.activeSetting.review_email_subject,
        review_email_body: this.activeSetting.review_email_body,
        auto_request_reviews_voice: this.activeSetting.auto_request_reviews_voice,
        auto_follow_up: this.activeSetting.auto_follow_up,
        follow_up_message: this.activeSetting.follow_up_message,
        follow_up_minutes: this.activeSetting.follow_up_minutes,
        auto_follow_up2: this.activeSetting.auto_follow_up2,
        follow_up2_message: this.activeSetting.follow_up2_message,
        follow_up2_minutes: this.activeSetting.follow_up2_minutes,
        widget_title: this.activeSetting.widget_title,
        widget_description: this.activeSetting.widget_description,
        floating_box_position: this.activeSetting.floating_box_position,
        widget_header_color: this.activeSetting.widget_header_color,
        widget_text_color: this.activeSetting.widget_text_color,
        widget_box_color: this.activeSetting.widget_box_color,
        widget_chat_bubble_left_color: this.activeSetting.widget_chat_bubble_left_color,
        widget_chat_bubble_right_color: this.activeSetting.widget_chat_bubble_right_color,
        widget_button_color: this.activeSetting.widget_button_color,
        voice_widget_title: this.activeSetting.voice_widget_title,
        voice_widget_text_color: this.activeSetting.voice_widget_text_color,
        voice_widget_box_color: this.activeSetting.voice_widget_box_color,
        voice_widget_talk_button_color: this.activeSetting.voice_widget_talk_button_color,
        voice_widget_mute_button_color: this.activeSetting.voice_widget_mute_button_color,
        voice_widget_end_button_color: this.activeSetting.voice_widget_end_button_color,
        knowledgebase_files: this.activeSetting.knowledgebase_files,
        knowledgebase_websites: this.activeSetting.knowledgebase_websites,
        recording_notification_message: this.activeSetting.recording_notification_message,
        recording_notification_enabled: !!this.activeSetting.recording_notification_enabled,
        first_sentence: this.activeSetting.first_sentence,
        retell_transfer: this.activeSetting.retell_transfer,
        retell_speech_settings: this.activeSetting.retell_speech_settings,
        retell_call_settings: this.activeSetting.retell_call_settings,
        retell_voice_model: this.activeSetting.retell_voice_model,
        retell_llm_settings: this.activeSetting.retell_llm_settings,
        show_powered_by: this.activeSetting.show_powered_by,
        powered_by_link: this.activeSetting.powered_by_link,
        powered_by_text: this.activeSetting.powered_by_text,
        auto_popup: this.activeSetting.auto_popup,
        auto_popup_seconds: this.activeSetting.auto_popup_seconds,
        chat_widget_pages: this.getChatWidgetPages(),
        additional_numbers: this.activeSetting.additional_numbers || []
      };

      try {
        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/agency/save-bland-settings`, params, {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.auth.jwt }
        });
          
        // Re-fetch prompt versions and automatically select the newly generated/saved active version
        await this.fetchVersions();

        if (silent) this.showDiff = true;

        if (response.data.success) {
          this.errorBland = false;

          if (!silent) {
            this.$swal({
              title: "Settings saved!",
              text: "Your AI settings have been successfully saved.",
              showCancelButton: false
            });
          }
        } else {
          this.errorBland = response.data.error;
        }
      } catch(e) {
        console.error(e);
      }
      this.savingBland = false;
    },

    openBuyAdditionalNumberDialog() {
      // Open the buyNumber dialog — source defaults to lsa but user can change it in the dialog
      this.$refs.buyNumber.show('lsa');
    },

    removeAdditionalNumber(index) {
      if (!this.activeSetting || !this.activeSetting.additional_numbers) return;
      this.$delete(this.activeSetting.additional_numbers, index);
    }
  },
  created() {
    this.fetchRetellVoices();
    this.getGhlCalendars();
  },
  async mounted() {
    // Check if we arrived with a pending prompt revision via localStorage
    if (this.$route.query.pending_revision === 'true') {
      const rawData = localStorage.getItem('pending_prompt_revision');
      
      if (rawData) {
        try {
          const promptData = JSON.parse(rawData);
          
          this.showTester = true;
          this.showDiff = true;
          
          // Wrap the nextTick callback in an async function to use await
          await this.$nextTick(async () => {
            if (this.activeSetting && promptData.revised_prompt) {
              this.activeSetting.call_prompt = promptData.revised_prompt;
            }
            
            // Now you can successfully await your save method
            await this.saveBlandSettings(true);

            if (promptData.test_input) {
              this.testerInput = promptData.test_input;
              if (promptData.auto_test == 1) {
                this.runTesterMessage();
              }
            }
          });
        } catch (e) {
          console.error('Failed to parse pending prompt revision from localStorage', e);
        } finally {
          // Clean up localStorage immediately after reading
          localStorage.removeItem('pending_prompt_revision');
        }
      }
    }
  },
  watch: {
    me: {
      handler(newMe) {
        if (newMe.integrations.bland.settings) {
          if (newMe.integrations.bland.status === 1) {
            this.blandNumberSelected = newMe.integrations.bland.settings[0];
          }
        }
      },
      immediate: true
    },
    serviceOptions: {
      handler() {
        if (this.activeSetting && this.activeSetting.selected_ghl_calendar_id && !this.activeSetting.selected_ghl_duration_option) {
          this.onCalendarChange(this.activeSetting.selected_ghl_calendar_id)
        }
      },
      immediate: true
    },
    activeSetting: {
      handler(val) {
        if (val && val.phone_number && this.promptVersions.length === 0) {
          this.fetchVersions();
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
/* Strict Top Header Fix on Desktop */
@media (min-width: 960px) {
  .retell-header-fixed {
    height: 48px !important;
    max-height: 48px !important;
    min-height: 48px !important;
  }
}

/* Retell Single-Card Drawer Container */
.retell-drawer-container {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
}

/* Border Separators between Accordions */
.retell-panel-border {
  border-bottom: 1px solid #f1f5f9 !important;
}
.retell-panel-border:last-child {
  border-bottom: none !important;
}

/* High-Contrast Primary Save Button */
.retell-btn-primary {
  background-color: #0f172a !important;
  color: #ffffff !important;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.retell-btn-primary:hover {
  background-color: #1e293b !important;
}

.retell-textarea {
  resize: none !important;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  outline: none;
  color: #1e293b;
  width: 100%;
  padding: 10px;
}

.retell-input {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  outline: none;
  color: #1e293b;
  width: 100%;
  padding: 5px;
}

.retell-input:focus, .retell-textarea:focus {
  border-color: #94a3b8;
  background: #ffffff;
}

.retell-pill {
  display: flex;
  align-items: center;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 2px 8px;
  height: 28px;
  margin-right: 10px;
}

.retell-inline-input {
  border: 1px transparent;
  border-radius: 4px;
  padding: 2px 6px;
  background: transparent;
  outline: none;
}
.retell-inline-input:hover, .retell-inline-input:focus {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.retell-select-clean {
  background: transparent;
  border: none;
  outline: none;
  color: #334155;
  cursor: pointer;
}

.retell-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.retell-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 2px;
}

.retell-slider {
  width: 100%;
  accent-color: #0f172a;
  height: 4px;
  border-radius: 2px;
  cursor: pointer;
}

.retell-toggle {
  accent-color: #10b981;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.retell-chip {
  display: inline-flex;
  align-items: center;
  background-color: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  padding: 2px 8px;
  color: #334155;
}

.retell-btn-secondary {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #334155;
  cursor: pointer;
  transition: background-color 0.15s ease;
}
.retell-btn-secondary:hover {
  background-color: #f8fafc;
}

.retell-accordion >>> .v-expansion-panel-header {
  min-height: 32px !important;
  padding: 6px 10px !important;
  background: #ffffff !important;
}

.retell-v-select >>> .v-input__control {
  min-height: 28px !important;
}

.prompt-diff {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  color: #1e293b;
  box-sizing: border-box;
}

/* High-contrast highlight styling */
.prompt-diff-added {
  background-color: #bbf7d0 !important;
  color: #14532d !important;
  font-weight: 600;
  padding: 1px 2px;
  border-radius: 2px;
  display: inline;
}

.prompt-diff-removed {
  background-color: #fca5a5 !important;
  color: #7f1d1d !important;
  text-decoration: line-through;
  padding: 1px 2px;
  border-radius: 2px;
  display: inline;
  opacity: 0.9;
}

.playground-messages {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.playground-message {
  padding: 6px 10px;
  margin-bottom: 6px;
  border-radius: 6px;
  font-size: 11px;
  max-width: 85%;
}

.playground-message.user {
  background: #dbeafe;
  margin-left: auto;
  color: #1e40af;
}

.playground-message.assistant {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  margin-right: auto;
  color: #334155;
}

/* ========================================================
   Mobile-Responsive Enhancements (smAndDown / < 960px)
   ======================================================== */
@media (max-width: 959px) {
  /* Dynamic Sticky Mobile Header */
  .retell-header-fixed {
    height: auto !important;
    max-height: none !important;
    min-height: auto !important;
    position: sticky !important;
    top: 0 !important;
    z-index: 40 !important;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06) !important;
  }

  /* Full Page Natural Scrolling on Mobile */
  .retell-app-viewport {
    height: auto !important;
    min-height: 100vh !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  /* Unconstrain Workspace Container */
  .retell-workspace-container {
    overflow-y: visible !important;
    overflow-x: hidden !important;
    height: auto !important;
    min-height: 0 !important;
    display: block !important;
    padding: 10px 8px 60px 8px !important;
  }

  /* Allow Columns to Stack Naturally */
  .retell-workspace-row {
    flex-wrap: wrap !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    gap: 0 !important;
  }

  /* Full-width Responsive Columns */
  .retell-canvas-col,
  .retell-drawer-col {
    height: auto !important;
    min-height: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    overflow-y: visible !important;
    padding: 0 !important;
  }

  .retell-canvas-col {
    margin-bottom: 16px !important;
  }

  /* Touch-Friendly Horizontal Pill Bar */
  .mobile-pills-bar {
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .mobile-pills-bar::-webkit-scrollbar {
    display: none;
  }

  .mobile-pills-bar .retell-pill {
    margin-right: 6px !important;
  }

  /* Expansion Panel Headers Touch Target Sizing & Clear Section Styling */
  .retell-accordion >>> .v-expansion-panel-header {
    min-height: 44px !important;
    padding: 11px 12px !important;
    font-size: 12.5px !important;
    font-weight: 600 !important;
    background-color: #f8fafc !important;
    border-bottom: 1px solid #f1f5f9 !important;
  }

  .retell-accordion >>> .v-expansion-panel-content__wrap {
    padding: 12px 10px !important;
  }

  /* System Prompt Card Comfort Height */
  .retell-textarea {
    min-height: 180px;
  }
}
</style>
